import { formatDate } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { StepperSelectionEvent } from '@angular/cdk/stepper';
import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    Inject,
    OnDestroy,
    OnInit,
    Optional,
    ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { FormControl } from '@angular/forms';
import { Observable, firstValueFrom, from, of, Subscription, forkJoin, throwError } from 'rxjs';
import { catchError, concatMap, debounceTime, finalize, map, switchMap, take, tap, toArray } from 'rxjs/operators';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { AusstallenService } from '../../../../../projects/kiene-core/src/lib/components/ausstallen/ausstallen.service';
import { AusstallenDialogInput, AusstallenDialogResult } from '../../../../../projects/kiene-core/src/lib/components/ausstallen/ausstallen-dialog/ausstallen-dialog';
import { AusstallenDialogComponent } from '../../../../../projects/kiene-core/src/lib/components/ausstallen/ausstallen-dialog/ausstallen-dialog.component';
import {
    AusstallenEmpfaengerDialogComponent,
    AusstallenEmpfaengerDialogResult,
} from '../../../../../projects/kiene-core/src/lib/components/ausstallen/ausstallen-empfaenger-dialog/ausstallen-empfaenger-dialog.component';
import {
    ExternEmpfaengerDisplayEntry,
    filterAktiveBetriebskontakteTierlisteVerbindungen,
    getExternEmpfaengerDisplayEntries,
    hasExternEmpfaenger,
    mapBetriebskontakteTierlisteVerbindungenToKontakte,
    patchTierlisteFromInternZielbetrieb,
    resolveTierlisteExtern,
    unwrapBetriebskontakteTierlisteReadResponse,
} from '../../../../../projects/kiene-core/src/lib/components/gruppe-tier/tierliste-zielbetrieb-display.util';
import { Betriebskontakt } from '../../../../../projects/kiene-core/src/lib/components/stammdaten/betriebskontakte/betriebskontakt';
import { BenutzerBetriebskontakteTierlisteService } from '../../../../../projects/kiene-core/src/lib/services/backend-api/benutzer-betriebskontakte-tierliste.service';
import { Client } from '../../../../../projects/kiene-core/src/lib/components/client/classes/client';
import { Gruppe, isGruppeSichtbarFuerAusstallenUmstallen } from '../../../../../projects/kiene-core/src/lib/components/gruppen/classes/gruppe';
import { EinstallenService } from '../../../../../projects/kiene-core/src/lib/components/gruppen/gruppe-einstallen/einstallen.service';
import { GruppenService } from '../../../../../projects/kiene-core/src/lib/components/gruppen/gruppen.service';
import { KieneBackendApiService } from '../../../../../projects/kiene-core/src/lib/services/backend-api/kiene-backend-api.service';
import { LocalStorageService } from '../../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import {
    EinstallenHitOptionen,
    EinstallenMeldenOverview,
    EinstallenSubmitFlowService,
} from '../../../../../projects/kiene-core/src/lib/components/gruppen/gruppe-einstallen/einstallen-submit-flow.service';
import { ChangeCurrentClientService } from '../../../administration/client/change-current-client/change-current-client.service';
import {
    DASHBOARD_TIER_ACTION_OPTIONS,
    DashboardTierAction,
    DashboardTierActionOption,
} from './dashboard-tier-action';
import { StammdatenService } from '../../../../../projects/kiene-core/src/lib/components/stammdaten/stammdaten.service';
import {
    ohneTierlisteKommentar,
    Tierliste,
} from '../../../../../projects/kiene-core/src/lib/components/gruppe-tier/classes/tierliste';
import { GruppeTier } from '../../../../../projects/kiene-core/src/lib/components/gruppe-tier/classes/gruppe-tier';
import { GruppeAbgangService } from '../../../../../projects/kiene-core/src/lib/components/gruppen/gruppe-abgang/gruppe-abgang.service';
import { isAbgangTierlisteGlobal } from '../../../../../projects/kiene-core/src/lib/components/gruppen/gruppe-abgang/abgang-tier-lookup.util';
import { GruppeAnlegenDialogComponent } from '../../../../../projects/kiene-core/src/lib/components/gruppen/gruppe-anlegen-dialog/gruppe-anlegen-dialog.component';
import { GruppeAnlegenDialogInput } from '../../../../../projects/kiene-core/src/lib/components/gruppen/gruppe-anlegen-dialog/gruppe-anlegen-dialog';
import { isTierlisteClosed } from '../letzte-aktionen/letzte-aktionen.models';
import { LetzteAktionenTierlisteMenuCacheService } from '../letzte-aktionen/letzte-aktionen-tierliste-menu-cache.service';
import {
    DashboardEinstallenStepperDialogData,
    DashboardSammelstellePrefillTier,
} from './dashboard-einstallen-stepper-dialog.data';
import { DashboardSammelstelleDialogComponent } from '../dashboard-sammelstelle-dialog/dashboard-sammelstelle-dialog.component';
import {
    DashboardSammelstelleDialogData,
    dashboardSammelstelleDialogLayout,
} from '../dashboard-sammelstelle-dialog/dashboard-sammelstelle-dialog.data';
import { isSammelstelleBetriebsart } from '../dashboard-sammelstelle-dialog/dashboard-sammelstelle-access';
import { DashboardSammelstelleSaveService } from '../dashboard-sammelstelle-dialog/dashboard-sammelstelle-save.service';
import {
    emptySammelnTier,
    parseGewichtKg,
    type SammelnTier,
} from '../dashboard-sammelstelle-dialog/dashboard-sammelstelle.types';
import { ScanErgebnis } from '../../../../../projects/kiene-core/src/lib/components/gruppen/classes/scan-ergebnis';
import { KieneUtils } from '../../../../../projects/kiene-core/src/lib/utils/KieneUtils';
import {
    isValidOhrmarkePassScanLength,
    normalizeOhrmarkePassScanInput,
    PASS_SCAN_LENGTH,
} from '../../../../../projects/kiene-core/src/lib/utils/ohrmarke-pass-scan.util';

const PERMISSION_EINSTALLEN_PRIMARY = 1912;
const PERMISSION_EINSTALLEN_SECONDARY = 9122;

const STEP_KUNDE = 0;
const STEP_AKTION = 1;
const STEP_GRUPPE = 2;

type CompactStepNavState = 'upcoming' | 'current' | 'done' | 'reachable';

interface CompactStepNavItem {
    index: number;
    label: string;
    state: CompactStepNavState;
    clickable: boolean;
    displayNumber: number;
}

@Component({
    selector: 'kiene-dashboard-einstallen-stepper-dialog',
    templateUrl: './dashboard-einstallen-stepper-dialog.component.html',
    styleUrls: ['./dashboard-einstallen-stepper-dialog.component.scss'],
    providers: [DashboardSammelstelleSaveService],
})
export class DashboardEinstallenStepperDialogComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild('stepper') stepper: MatStepper;
    @ViewChild('embeddedAusstallen') embeddedAusstallenDialog?: AusstallenDialogComponent;
    @ViewChild('embeddedEmpfaengerPicker') embeddedEmpfaengerPicker?: AusstallenEmpfaengerDialogComponent;
    @ViewChild('embeddedZielbetriebPicker') embeddedZielbetriebPicker?: AusstallenEmpfaengerDialogComponent;
    currentStep = 0;
    /** Highest step index the user has opened in this session (enables returning with preserved UI). */
    maxVisitedStepIndex = 0;
    compactStepNavItems: CompactStepNavItem[] = [];
    canChangeClient = false;
    private isOpeningClientDialog = false;

    selectedClient: Client;
    selectedAction: DashboardTierAction | null = null;
    readonly actionOptions = DASHBOARD_TIER_ACTION_OPTIONS;

    gruppen: Gruppe[] = [];
    selectedGruppe: Gruppe | null = null;
    gruppe: Gruppe | null = null;
    /** Global Ausstalliste: browse all groups on tier step (no preload). */
    tierQuelleGlobal = false;
    tierQuelleGruppeId: number | null = null;
    /** Stable array for tier lookup (avoid new reference every change detection). */
    tierBrowseGruppeIds: number[] = [];

    isLoadingGruppen = false;
    isLoadingGruppe = false;
    isLoadingReview = false;
    isSubmitting = false;
    isClosingTierliste = false;
    showEinstallenOverview = false;

    /** Daten für embedded `kiene-ausstallen-dialog` (Ausstallen/Umstallen Schritt). */
    ausstallenInput: AusstallenDialogInput | null = null;
    abgangTierliste: Tierliste | null = null;
    /** Aktive Ausstallliste für Scans im Schritt „Tiere auswählen“. */
    tierauswahlAbgangsliste: Tierliste | null = null;
    isPreparingTierauswahlAbgang = false;
    private isAusstallenAbschliessenRunning = false;
    anzahlTiereInAbgangListe = 0;

    overview: EinstallenMeldenOverview = this.createEmptyOverview();
    hitOptionen: EinstallenHitOptionen = {
        passUndOhrmarke: false,
        nurPassGescannt: false,
        nurOhrmarkeGescannt: false,
        wederPassNochOhrmarke: false,
    };
    canEditGewicht = false;
    gewichtScans: ScanErgebnis[] = [];

    /** Ausstallen extern: Empfänger vor „Tiere auswählen“. */
    empfaengerSchlachthof: Client | null = null;
    empfaengerKontakte: Betriebskontakt[] = [];
    empfaengerDisplayEntries: ExternEmpfaengerDisplayEntry[] = [];

    /** Umstallen: Zielbetrieb vor „Tiere auswählen“. */
    selectedZielbetrieb: Client | null = null;
    tierSucheCtrl = new FormControl('', { nonNullable: true });
    ausstallenTierKandidaten: GruppeTier[] = [];
    selectedAusstallenTierIds = new Set<number>();
    isLoadingAusstallenTiere = false;
    tierlisteMode: 'new' | 'existing' | null = null;
    bestehendeTierlisten: Tierliste[] = [];
    selectedBestehendeTierliste: Tierliste | null = null;
    isLoadingBestehendeTierlisten = false;
    /** True after the first successful load of open tierlisten for the current context. */
    bestehendeTierlistenLoaded = false;

    private lastAppliedTierlistenLoadContextKey: string | null = null;
    private loadBestehendeTierlistenRequestId = 0;
    /** Hides stale list cards while re-fetching after returning to Liste wählen. */
    private tierlistenStepRefreshPending = false;

    private gruppenSubscription?: Subscription;
    private gruppeSubscription?: Subscription;
    private ausstallenTiereSubscription?: Subscription;
    private bestehendeTierlistenSubscription?: Subscription;
    private tierauswahlAbgangSubscription?: Subscription;
    private prepareTierauswahlAbgangSubscription?: Subscription;
    private reviewSubscription?: Subscription;
    private continueDirectScanSubscription?: Subscription;
    private prefillInitializationDone = false;
    private continueAbgangTierlisteSubscription?: Subscription;
    private empfaengerPrefillSubscription?: Subscription;
    private empfaengerPrefillTierlisteId = 0;
    private sammelstellePrefillSubscription?: Subscription;
    private pendingEmpfaengerStepAdvance = false;
    private pendingZielbetriebStepAdvance = false;
    /** Survives Gruppe selection when Sammelstelle had no Zielgruppe. */
    private sammelstellePendingTiere: DashboardSammelstellePrefillTier[] = [];
    private sammelstellePendingDatum: string | null = null;

    constructor(
        public dialogRef: MatDialogRef<DashboardEinstallenStepperDialogComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) private readonly dialogData: DashboardEinstallenStepperDialogData | null,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
        private readonly api: KieneBackendApiService,
        private readonly localStorageService: LocalStorageService,
        private readonly gruppenService: GruppenService,
        private readonly messageService: MessageService,
        private readonly einstallenService: EinstallenService,
        private readonly einstallenSubmitFlow: EinstallenSubmitFlowService,
        private readonly changeCurrentClientService: ChangeCurrentClientService,
        private readonly abgangService: GruppeAbgangService,
        private readonly stammdatenService: StammdatenService,
        private readonly dialog: MatDialog,
        private readonly cdr: ChangeDetectorRef,
        private readonly tierlisteMenuCache: LetzteAktionenTierlisteMenuCacheService,
        private readonly ausstallenService: AusstallenService,
        private readonly bbtService: BenutzerBetriebskontakteTierlisteService,
        private readonly sammelstelleSaveService: DashboardSammelstelleSaveService,
    ) {
        this.selectedClient = this.localStorageService.getCurrentClient();
        this.canChangeClient = this.localStorageService.hasPermission(4511);
        if (this.isContinueDirectScanMode) {
            this.selectedAction = 'einstallen';
            this.currentStep = 0;
        } else if (this.isContinueAbgangTierlisteMode) {
            this.selectedAction = 'ausstallen_extern';
            this.currentStep = 0;
        } else if (this.hasSammelstellePrefillQueue) {
            this.selectedAction = 'einstallen';
            // Stay on Kunde/Aktion until AfterViewInit navigates — do not pretend we are on Gruppe
            // (that skips Material stepper sync and leaves the Betrieb step visible).
            this.currentStep = this.hasClientChosen ? STEP_AKTION : STEP_KUNDE;
            this.captureSammelstellePendingFromDialogData();
        } else {
            this.currentStep = this.hasClientChosen ? STEP_AKTION : STEP_KUNDE;
        }
        if (this.isContinuePrefilledMode) {
            this.isLoadingGruppe = true;
        }
    }

    ngOnInit(): void {
        document.body.classList.add('einstallen-dialog-open');
        this.canEditGewicht = this.einstallenSubmitFlow.currentUserCanEditGewicht();
        if (this.hasClientChosen && !this.isContinuePrefilledMode) {
            this.loadGruppen();
        }
        this.tierauswahlAbgangSubscription = this.abgangService.watchAbgangsliste().subscribe({
            next: reload => {
                if (!reload?.tierliste?.tierliste_id) {
                    return;
                }
                this.tierauswahlAbgangsliste = reload.tierliste;
                this.abgangTierliste = reload.tierliste;
                this.anzahlTiereInAbgangListe = Number(reload.tierliste.anzahl_tiere ?? 0);
                this.ensureAusstallenInputBuilt();
            },
        });
    }

    ngAfterViewInit(): void {
        if (this.dialogData?.continueDirectScan) {
            setTimeout(() => this.initContinueDirectScan(), 0);
            return;
        }
        if (this.dialogData?.continueAbgangTierliste) {
            setTimeout(() => this.initContinueAbgangTierliste(), 0);
            return;
        }
        if (this.hasSammelstellePrefillQueue) {
            setTimeout(() => this.initSammelstellePrefillWithoutGruppe(), 0);
            return;
        }
        if (this.hasClientChosen) {
            setTimeout(() => {
                if (this.stepper) {
                    this.navigateToStep(STEP_AKTION, this.stepper.selectedIndex);
                }
            }, 0);
        } else if (this.canChangeClient) {
            setTimeout(() => {
                this.openClientDialog();
            }, 0);
        }
        setTimeout(() => this.refreshCompactStepNav(), 0);
    }

    ngOnDestroy(): void {
        document.body.classList.remove('einstallen-dialog-open');
        this.gruppenSubscription?.unsubscribe();
        this.gruppeSubscription?.unsubscribe();
        this.ausstallenTiereSubscription?.unsubscribe();
        this.bestehendeTierlistenSubscription?.unsubscribe();
        this.tierauswahlAbgangSubscription?.unsubscribe();
        this.prepareTierauswahlAbgangSubscription?.unsubscribe();
        this.reviewSubscription?.unsubscribe();
        this.continueDirectScanSubscription?.unsubscribe();
        this.continueAbgangTierlisteSubscription?.unsubscribe();
        this.sammelstellePrefillSubscription?.unsubscribe();
        this.empfaengerPrefillSubscription?.unsubscribe();
    }

    /** Active step for content + compact nav (kept in sync via navigateToStep). */
    get stepDisplayIndex(): number {
        return this.currentStep;
    }

    /** Step body visibility — currentStep is synced with the stepper in navigateToStep / stepChanged. */
    isActiveStep(stepIndex: number | null): boolean {
        if (stepIndex == null) {
            return false;
        }
        if (this.isContinuePrefilledMode) {
            return this.isActiveMaterialStepByIndex(stepIndex);
        }
        if (this.currentStep === stepIndex) {
            return true;
        }
        const materialIndex = this.stepper?.selectedIndex;
        return typeof materialIndex === 'number' && materialIndex === stepIndex;
    }

    /** Compact continue flows: Material step index matches buildStepLabels() order. */
    isActiveMaterialStep(label: string): boolean {
        const idx = this.buildStepLabels().indexOf(label);
        return idx >= 0 && this.isActiveMaterialStepByIndex(idx);
    }

    private isActiveMaterialStepByIndex(index: number): boolean {
        const materialIndex = this.stepper?.selectedIndex;
        return this.currentStep === index || materialIndex === index;
    }

    get showStepperWorkflow(): boolean {
        if (this.isContinuePrefilledMode) {
            return this.hasActionChosen;
        }
        return true;
    }

    /** Full-height layout for embedded kiene-einstallen-uebersicht (Scans fortsetzen / Einstallen step). */
    get fillDialogForEinstallenOverview(): boolean {
        const einstallIx = this.ix.workflowEinstallen;
        if (einstallIx === null || !this.isEinstallenFlow || !this.showEinstallenOverview) {
            return false;
        }
        return this.isActiveStep(einstallIx);
    }

    /** Embedded Ausstallen/Umstallen form step (always uses stepper footer, not inline actions). */
    get isEmbeddedAusstallenStepActive(): boolean {
        const ausstallenIx = this.ix.workflowAusstallen;
        return (
            this.isAusstallenFlow &&
            ausstallenIx !== null &&
            this.isActiveStep(ausstallenIx) &&
            this.hasTierauswahlForAusstallen &&
            !!this.ausstallenInput
        );
    }

    /** Final step of the current workflow (Ausstallen, Prüfen & melden, …). */
    get isOnLastStep(): boolean {
        const labels = this.buildStepLabels();
        if (!labels.length) {
            return false;
        }
        const lastLabel = labels[labels.length - 1];
        if (this.isContinuePrefilledMode) {
            return this.isActiveMaterialStep(lastLabel);
        }
        const lastIx = this.stepIndexForLabel(lastLabel);
        return lastIx !== null && this.isActiveStep(lastIx);
    }

    /** Fixed-height scroll body so mat-dialog-actions stay pinned at the bottom. */
    get useDialogContentScrollLayout(): boolean {
        if (this.useDialogContentFlexLayout) {
            return false;
        }
        if (this.isPrefillInitializing || this.fillDialogForEinstallenOverview || this.isOnLastStep) {
            return true;
        }
        return this.isOnTiereAuswahlStep;
    }

    /**
     * Empfänger / Zielbetrieb: flex-fill layout with inner scroll on the embedded picker
     * (same pattern as the standalone modal's mat-dialog-content).
     */
    get useDialogContentFlexLayout(): boolean {
        return this.isOnScrollableAbgangPickerStep;
    }

    /** Steps with embedded destination pickers (Empfänger / Zielbetrieb). */
    private get isOnScrollableAbgangPickerStep(): boolean {
        return this.isAbgangZielPickerStepActive;
    }

    get isAbgangZielPickerStepActive(): boolean {
        return this.isOnEmpfaengerStepActive || this.isOnZielbetriebStepActive;
    }

    get isOnEmpfaengerStepActive(): boolean {
        if (!this.showEmpfaengerStep || this.ix.empfaenger === null) {
            return false;
        }
        return this.isContinueAbgangTierlisteMode
            ? this.isActiveMaterialStep('Empfänger')
            : this.isActiveStep(this.ix.empfaenger);
    }

    get isOnZielbetriebStepActive(): boolean {
        if (!this.showZielbetriebStep || this.ix.zielbetrieb === null) {
            return false;
        }
        return this.isContinueAbgangTierlisteMode
            ? this.isActiveMaterialStep('Zielbetrieb')
            : this.isActiveStep(this.ix.zielbetrieb);
    }

    private get isOnTiereAuswahlStep(): boolean {
        const step = this.currentStep;
        const ix = this.ix;
        return ix.tiereAuswahl !== null && step === ix.tiereAuswahl;
    }

    goToCompactStep(index: number): void {
        if (index > this.maxVisitedStepIndex) {
            return;
        }
        this.navigateToStep(index);
    }

    /** Single entry point for step changes — updates stepper, currentStep, and compact nav. */
    private navigateToStep(index: number, previousIndex?: number): boolean {
        if (!this.stepper || index < 0) {
            return false;
        }
        const steps = this.stepper.steps;
        if (index >= steps.length) {
            return false;
        }
        const materialIndex =
            typeof this.stepper.selectedIndex === 'number' ? this.stepper.selectedIndex : -1;
        const prev = typeof previousIndex === 'number' ? previousIndex : this.currentStep;
        // Already synced — nothing to do.
        if (index === this.currentStep && index === materialIndex) {
            return true;
        }
        const targetStep = steps.get(index);
        if (!targetStep) {
            return false;
        }
        this.stepper.selected = targetStep;
        this.stepper.selectedIndex = index;
        this.applyStepIndexChange(index, prev);
        if (this.stepper.selectedIndex !== index) {
            this.currentStep = index;
            this.refreshCompactStepNav();
        }
        return this.stepper.selectedIndex === index;
    }

    /** Maps logical step to Material index (matches mat-step order in template). */
    private stepIndexForLabel(label: string): number | null {
        const idx = this.buildStepLabels().indexOf(label);
        return idx >= 0 ? idx : null;
    }

    /** In compact continue flows, missing labels must not fall back to 0/1/2 (collides with real steps). */
    private stepIndexForLabelOrLegacy(label: string, legacyIndex: number): number | null {
        const idx = this.stepIndexForLabel(label);
        if (idx !== null) {
            return idx;
        }
        return this.isContinuePrefilledMode ? null : legacyIndex;
    }

    private buildStepLabels(): string[] {
        if (this.isContinueDirectScanMode) {
            return ['Einstallen', 'Prüfen & melden'];
        }
        if (this.isContinueAbgangTierlisteMode) {
            const labels: string[] = [];
            if (!this.isContinueAbgangAtAusstallenStep) {
                if (this.showEmpfaengerStep) {
                    labels.push('Empfänger');
                }
                if (this.showZielbetriebStep) {
                    labels.push('Zielbetrieb');
                }
                labels.push('Tiere auswählen');
            }
            labels.push(this.ausstallenActionLabel);
            return labels;
        }
        const labels = ['Kunde', 'Aktion'];
        if (this.showTierlisteAuswahlStep) {
            labels.push('Liste wählen');
        }
        labels.push('Gruppe');
        if (this.isAusstallenFlow) {
            if (this.showEmpfaengerStep) {
                labels.push('Empfänger');
            }
            if (this.showZielbetriebStep) {
                labels.push('Zielbetrieb');
            }
            labels.push('Tiere auswählen');
        }
        if (this.isEinstallenFlow) {
            labels.push('Einstallen');
        }
        if (this.isAusstallenFlow) {
            labels.push(this.ausstallenActionLabel);
        }
        if (this.isEinstallenFlow) {
            labels.push('Prüfen & melden');
        }
        return labels;
    }

    get showCompactStepNav(): boolean {
        if (this.isContinuePrefilledMode) {
            return this.compactStepNavItems.length >= 1;
        }
        return this.compactStepNavItems.length > 1;
    }

    private refreshCompactStepNav(): void {
        const steps = this.stepper?.steps?.toArray() ?? [];
        const labels = this.buildStepLabels();
        const stepCount = this.isContinuePrefilledMode
            ? labels.length
            : steps.length > 0
              ? steps.length
              : labels.length;
        const selectedIndex = this.currentStep;

        this.compactStepNavItems = Array.from({ length: stepCount }, (_, index) => {
            const label = labels[index] ?? `Schritt ${index + 1}`;
            const isCurrent = selectedIndex === index;
            let state: CompactStepNavState = 'upcoming';
            if (isCurrent) {
                state = 'current';
            } else if (index < selectedIndex) {
                state = 'done';
            } else if (index <= this.maxVisitedStepIndex) {
                state = 'reachable';
            }
            return {
                index,
                label,
                state,
                clickable: !isCurrent && index <= this.maxVisitedStepIndex,
                displayNumber: index + 1,
            };
        });
    }

    /** Continue flows: fixed-height shell while gruppe/tierliste data loads. */
    get isPrefillInitializing(): boolean {
        return this.isContinuePrefilledMode && this.isLoadingGruppe;
    }

    /** Sticky Weiter/Zurück bar — always visible so dialog height stays stable while loading. */
    get showStickyFooterNav(): boolean {
        return true;
    }

    get ausstallenSaveBlockedMessage(): string | null {
        if (!this.isEmbeddedAusstallenStepActive) {
            return null;
        }
        return this.embeddedAusstallenDialog?.saveBlockedMessage ?? null;
    }

    get showFooterBack(): boolean {
        return this.currentStep > 0;
    }

    get isReviewStepActive(): boolean {
        return this.ix.review !== null && this.isActiveStep(this.ix.review);
    }

    get footerPrimaryLabel(): string {
        if (this.isEmbeddedAusstallenStepActive) {
            return this.embeddedAusstallenSubmitLabel;
        }
        if (this.isOnSkippableEmpfaengerOrZielbetriebStep) {
            return 'Überspringen';
        }
        return 'Weiter';
    }

    /** Empfänger / Zielbetrieb optional — „Weiter“ without selection becomes „Überspringen“. */
    get isOnSkippableEmpfaengerOrZielbetriebStep(): boolean {
        const step = this.currentStep;
        const ix = this.ix;
        if (ix.empfaenger !== null && step === ix.empfaenger && !this.hasEmpfaengerChosen) {
            return true;
        }
        if (ix.zielbetrieb !== null && step === ix.zielbetrieb && !this.hasZielbetriebChosen) {
            return true;
        }
        return false;
    }

    get footerPrimaryDisabled(): boolean {
        if (this.isPrefillInitializing) {
            return true;
        }
        if (this.isEmbeddedAusstallenStepActive) {
            const dlg = this.embeddedAusstallenDialog;
            if (!dlg) {
                return true;
            }
            return this.isAusstallenAbschliessenRunning || dlg.isSaving || !dlg.canSave;
        }
        const step = this.currentStep;
        const ix = this.ix;
        if (ix.kunde !== null && step === ix.kunde) {
            return !this.hasClientChosen;
        }
        if (ix.aktion !== null && step === ix.aktion) {
            return !this.hasActionChosen || this.visibleActionOptions.length === 0;
        }
        if (ix.tierlisteAuswahl !== null && step === ix.tierlisteAuswahl) {
            return !this.hasTierlisteChoice;
        }
        if (ix.gruppe !== null && step === ix.gruppe) {
            return !this.hasGruppeChosen || this.isLoadingGruppe || this.isLoadingGruppen;
        }
        if (ix.empfaenger !== null && step === ix.empfaenger) {
            const picker = this.embeddedEmpfaengerPicker;
            if (picker?.isSaving) {
                return true;
            }
            return this.isPreparingTierauswahlAbgang;
        }
        if (ix.zielbetrieb !== null && step === ix.zielbetrieb) {
            const picker = this.embeddedZielbetriebPicker;
            if (picker?.isSaving) {
                return true;
            }
            return this.isPreparingTierauswahlAbgang;
        }
        if (ix.tiereAuswahl !== null && step === ix.tiereAuswahl) {
            return !this.hasTierauswahlForAusstallen || this.isPreparingTierauswahlAbgang;
        }
        if (ix.workflowEinstallen !== null && step === ix.workflowEinstallen) {
            return !this.gruppe?.gruppe_id;
        }
        if (ix.review !== null && step === ix.review) {
            return this.isLoadingReview || this.isSubmitting || this.isClosingTierliste;
        }
        return true;
    }

    stepBack(): void {
        if (this.currentStep <= 0) {
            return;
        }
        this.navigateToStep(this.currentStep - 1);
    }

    footerPrimaryClick(): void {
        if (this.isEmbeddedAusstallenStepActive) {
            void this.abschliessenEmbeddedAusstallen();
            return;
        }
        const step = this.currentStep;
        const ix = this.ix;
        if (ix.kunde !== null && step === ix.kunde) {
            if (ix.aktion !== null) {
                this.navigateToStep(ix.aktion);
            }
            return;
        }
        if (ix.aktion !== null && step === ix.aktion) {
            const nextIx = this.showTierlisteAuswahlStep ? ix.tierlisteAuswahl : ix.gruppe;
            if (nextIx !== null) {
                this.navigateToStep(nextIx);
            }
            return;
        }
        if (ix.tierlisteAuswahl !== null && step === ix.tierlisteAuswahl) {
            this.continueFromTierlisteAuswahl();
            return;
        }
        if (ix.gruppe !== null && step === ix.gruppe) {
            const nextIx = this.isAusstallenFlow ? this.getAbgangStepAfterGruppe() : ix.workflowEinstallen;
            if (nextIx !== null) {
                this.navigateToStep(nextIx);
            }
            return;
        }
        if (ix.empfaenger !== null && step === ix.empfaenger) {
            const picker = this.embeddedEmpfaengerPicker;
            if (picker?.canSubmit && !picker.isSaving) {
                this.persistEmpfaengerFromEmbeddedStepper();
            } else if (!this.isPreparingTierauswahlAbgang && !picker?.isSaving) {
                this.continueFromEmpfaengerOrZielbetriebStep();
            }
            return;
        }
        if (ix.zielbetrieb !== null && step === ix.zielbetrieb) {
            const picker = this.embeddedZielbetriebPicker;
            if (picker?.canSubmit && !picker.isSaving) {
                this.persistZielbetriebFromEmbeddedStepper();
            } else if (!this.isPreparingTierauswahlAbgang && !picker?.isSaving) {
                this.continueFromEmpfaengerOrZielbetriebStep();
            }
            return;
        }
        if (ix.tiereAuswahl !== null && step === ix.tiereAuswahl) {
            this.continueFromTierauswahl();
            return;
        }
        if (ix.workflowEinstallen !== null && step === ix.workflowEinstallen) {
            this.goToReview();
            return;
        }
    }

    isDisplayedStep(ix: number | null): boolean {
        if (ix == null) {
            return false;
        }
        const selectedIndex = this.stepper?.selectedIndex;
        return this.stepDisplayIndex === ix || this.currentStep === ix || selectedIndex === ix;
    }

    /**
     * Material step order depends on selected action. Ausstallen: Liste wählen after Aktion.
     * Umstallen: Gruppe directly after Aktion (always new list). Einstallen: Gruppe after Aktion.
     */
    get ix(): {
        kunde: number | null;
        aktion: number | null;
        gruppe: number | null;
        empfaenger: number | null;
        tiereAuswahl: number | null;
        tierlisteAuswahl: number | null;
        zielbetrieb: number | null;
        workflowAusstallen: number | null;
        workflowAbgang: number | null;
        workflowEinstallen: number | null;
        review: number | null;
    } {
        return {
            kunde: this.stepIndexForLabelOrLegacy('Kunde', STEP_KUNDE),
            aktion: this.stepIndexForLabelOrLegacy('Aktion', STEP_AKTION),
            gruppe: this.stepIndexForLabelOrLegacy('Gruppe', STEP_GRUPPE),
            tierlisteAuswahl: this.stepIndexForLabel('Liste wählen'),
            empfaenger: this.stepIndexForLabel('Empfänger'),
            tiereAuswahl: this.stepIndexForLabel('Tiere auswählen'),
            zielbetrieb: this.stepIndexForLabel('Zielbetrieb'),
            workflowEinstallen: this.stepIndexForLabel('Einstallen'),
            workflowAusstallen: this.stepIndexForLabel(this.ausstallenActionLabel),
            workflowAbgang: null,
            review: this.stepIndexForLabel('Prüfen & melden'),
        };
    }

    get isUmstallenIntern(): boolean {
        return this.selectedAction === 'umstallen_intern';
    }

    get isAusstallenExtern(): boolean {
        return this.selectedAction === 'ausstallen_extern';
    }

    /** Only external Ausstallen offers new vs. existing list; Umstallen always creates a new list. */
    get showTierlisteAuswahlStep(): boolean {
        return this.isAusstallenExtern && !this.isContinueAbgangTierlisteMode;
    }

    /** Spinner only while loading existing lists after the user chose "Bestehende Liste verwenden". */
    get showBestehendeTierlistenLoading(): boolean {
        return (
            this.tierlisteMode === 'existing' &&
            this.isLoadingBestehendeTierlisten &&
            (!this.bestehendeTierlistenLoaded || this.tierlistenStepRefreshPending)
        );
    }

    get isTierlistenStepRefreshPending(): boolean {
        return this.tierlistenStepRefreshPending;
    }

    get canShowBestehendeTierlistenCards(): boolean {
        return (
            this.tierlisteMode === 'existing' &&
            !this.tierlistenStepRefreshPending &&
            !this.isLoadingBestehendeTierlisten &&
            this.bestehendeTierlisten.length > 0
        );
    }

    get tierlisteHasZielbetrieb(): boolean {
        const liste = this.getWorkingAbgangsTierliste();
        if (!liste) {
            return false;
        }
        return this.getTierlisteZielKundeId(liste) > 0;
    }

    /** Umstallen: Zielbetrieb step stays in the stepper after selection (stable step indices). */
    get showZielbetriebStep(): boolean {
        if (!this.isUmstallenIntern) {
            return false;
        }
        if (this.isContinueAbgangAtAusstallenStep) {
            return this.anzahlTiereInAbgangListe <= 0 && !this.tierlisteHasZielbetrieb;
        }
        return true;
    }

    /** Extern Ausstallen: Empfänger before animal selection. */
    get showEmpfaengerStep(): boolean {
        return this.isAusstallenExtern && !this.isContinueAbgangAtAusstallenStep;
    }

    get hasEmpfaengerChosen(): boolean {
        if (this.embeddedEmpfaengerPicker?.canSubmit) {
            return true;
        }
        return hasExternEmpfaenger(
            this.getWorkingAbgangsTierliste(),
            this.empfaengerKontakte,
            this.empfaengerSchlachthof,
        );
    }

    get empfaengerEmbeddedTierliste(): Tierliste | null {
        const liste = this.getWorkingAbgangsTierliste();
        return liste?.tierliste_id ? liste : null;
    }

    get hasZielbetriebChosen(): boolean {
        if (this.embeddedZielbetriebPicker?.canSubmit) {
            return true;
        }
        if (this.selectedZielbetrieb?.kunde_id && this.selectedZielbetrieb.kunde_id > 0) {
            return true;
        }
        return this.isUmstallenIntern && this.tierlisteHasZielbetrieb;
    }

    get hasClientChosen(): boolean {
        return !!(this.selectedClient?.kunde_id && this.selectedClient.kunde_id > 0);
    }

    get hasActionChosen(): boolean {
        return this.selectedAction != null;
    }

    get isEinstallenFlow(): boolean {
        return this.selectedAction === 'einstallen';
    }

    get isAusstallenFlow(): boolean {
        return this.selectedAction === 'ausstallen_extern' || this.selectedAction === 'umstallen_intern';
    }

    get hasGruppeChosen(): boolean {
        if (this.isAusstallenFlow) {
            return (
                this.tierQuelleGlobal ||
                !!(this.tierQuelleGruppeId && this.tierQuelleGruppeId > 0)
            );
        }
        return !!(this.gruppe?.gruppe_id && this.gruppe.gruppe_id > 0);
    }

    get isGlobalAbgangsliste(): boolean {
        return isAbgangTierlisteGlobal(this.getWorkingAbgangsTierliste());
    }

    /** „Global“ on the Gruppe step: browse animals from all groups (any tierliste type). */
    get showTierQuelleGlobalOption(): boolean {
        return this.isAusstallenFlow;
    }

    /** Group scope for tier lookup: one group or all groups from the Gruppe step („Global“). */
    get tierBrowseGruppeIdsForEingabe(): number[] {
        return this.tierBrowseGruppeIds;
    }

    private refreshTierBrowseGruppeIds(): void {
        if (!this.isAusstallenFlow) {
            const gid = Number(this.gruppe?.gruppe_id || 0);
            this.tierBrowseGruppeIds = gid > 0 ? [gid] : [];
            return;
        }
        if (this.tierQuelleGlobal) {
            this.tierBrowseGruppeIds = this.gruppen.map(g => Number(g.gruppe_id)).filter(id => id > 0);
            return;
        }
        const gid = Number(this.tierQuelleGruppeId || this.gruppe?.gruppe_id || 0);
        this.tierBrowseGruppeIds = gid > 0 ? [gid] : [];
    }

    get isTierEingabeReady(): boolean {
        return !!this.tierauswahlAbgangsliste?.tierliste_id && this.hasGruppeChosen;
    }

    get hasAbgangTierliste(): boolean {
        return !!(this.abgangTierliste?.tierliste_id && this.abgangTierliste.tierliste_id > 0);
    }

    get hasCompletedAusstallenWorkflowStep(): boolean {
        if (!this.isAusstallenFlow || this.ix.workflowAusstallen === null) {
            return false;
        }
        const selectedIndex = this.stepper?.selectedIndex;
        const activeIndex = typeof selectedIndex === 'number' ? selectedIndex : this.currentStep;
        return activeIndex > this.ix.workflowAusstallen;
    }

    get hasTierauswahlForAusstallen(): boolean {
        if (!this.isAusstallenFlow) {
            return true;
        }
        const count = Number(this.tierauswahlAbgangsliste?.anzahl_tiere ?? this.anzahlTiereInAbgangListe ?? 0);
        return count > 0;
    }

    get hasTierlisteChoice(): boolean {
        if (!this.isAusstallenFlow) {
            return true;
        }
        if (this.isUmstallenIntern) {
            return true;
        }
        if (this.tierlisteMode === 'new') {
            return true;
        }
        if (this.tierlisteMode === 'existing') {
            return !!this.selectedBestehendeTierliste?.tierliste_id;
        }
        return false;
    }

    get filteredAusstallenTierKandidaten(): GruppeTier[] {
        const search = (this.tierSucheCtrl.value || '').trim().toLowerCase();
        if (!search) {
            return this.ausstallenTierKandidaten;
        }
        return this.ausstallenTierKandidaten.filter(tier => {
            const ohrmarke = String((tier as any)?.ohrmarke_notnull || tier?.ohrmarke || '').toLowerCase();
            const pass = String((tier as any)?.passnummer || '').toLowerCase();
            return ohrmarke.includes(search) || pass.includes(search);
        });
    }

    get areAllVisibleAusstallenTiereSelected(): boolean {
        const visible = this.filteredAusstallenTierKandidaten;
        if (visible.length === 0) {
            return false;
        }
        return visible.every(tier => this.selectedAusstallenTierIds.has(Number(tier?.gt_id)));
    }

    get isContinueDirectScanMode(): boolean {
        const cfg = this.dialogData?.continueDirectScan;
        return Number(cfg?.gruppeId || 0) > 0;
    }

    /** Sammelstelle handoff without Zielgruppe yet (queue held until Gruppe chosen). */
    get hasSammelstellePrefillQueue(): boolean {
        return this.normalizePrefillTiere(
            this.dialogData?.sammelstellePrefill?.prefillTiere,
            this.dialogData?.sammelstellePrefill?.prefillOhrmarken,
        ).length > 0;
    }

    /** Liste abschliessen: skip Einstallen scan step and open Prüfen & melden directly. */
    get isContinueDirectScanAtReviewStep(): boolean {
        return this.isContinueDirectScanMode && this.dialogData?.continueDirectScan?.initialStep === 'review';
    }

    get isContinueAbgangTierlisteMode(): boolean {
        return Number(this.dialogData?.continueAbgangTierliste?.tierlisteId || 0) > 0;
    }

    /** Liste abschliessen: skip Tiere-auswählen step and open final Ausstallen form directly. */
    get isContinueAbgangAtAusstallenStep(): boolean {
        return (
            this.isContinueAbgangTierlisteMode &&
            this.dialogData?.continueAbgangTierliste?.initialStep === 'ausstallen'
        );
    }

    get showTiereAuswahlStep(): boolean {
        return this.isAusstallenFlow && !this.isContinueAbgangAtAusstallenStep;
    }

    get isContinuePrefilledMode(): boolean {
        return this.isContinueDirectScanMode || this.isContinueAbgangTierlisteMode;
    }

    get dialogTitle(): string {
        if (this.isContinueDirectScanMode) {
            return this.isContinueDirectScanAtReviewStep ? 'Liste abschliessen' : 'Scans fortsetzen';
        }
        if (this.isContinueAbgangTierlisteMode) {
            return this.dialogData?.continueAbgangTierliste?.initialStep === 'ausstallen'
                ? 'Liste abschliessen'
                : 'Scans fortsetzen';
        }
        if (this.sammelstellePendingTiere.length > 0 || this.hasSammelstellePrefillQueue) {
            return 'Tiere einstallen';
        }
        switch (this.selectedAction) {
            case 'einstallen':
                return 'Tiere einstallen';
            case 'ausstallen_extern':
                return 'Ausstallen';
            case 'umstallen_intern':
                return 'Umstallen';
            default:
                return 'Tiere bewegen';
        }
    }

    get visibleActionOptions(): DashboardTierActionOption[] {
        return this.actionOptions.filter(opt => this.canSelectAction(opt.action));
    }

    get gruppeStepIntro(): string {
        const pending = this.sammelstellePendingTiere.length;
        if (this.selectedAction === 'einstallen' && pending > 0) {
            return `Wählen Sie die Zielgruppe. ${pending} nicht gefundene ${
                pending === 1 ? 'Ohrmarke wird' : 'Ohrmarken werden'
            } danach in die Einstall-Liste übernommen.`;
        }
        switch (this.selectedAction) {
            case 'einstallen':
                return 'Wählen Sie die Gruppe, in die die Tiere eingestallt werden sollen.';
            case 'ausstallen_extern':
                return 'Wählen Sie eine Gruppe zum Durchsuchen der Tiere oder „Global“, um Tiere aus allen Gruppen per Suche hinzuzufügen.';
            case 'umstallen_intern':
                return 'Wählen Sie die Ausgangsgruppe oder „Global“, um Tiere aus allen Gruppen per Suche hinzuzufügen.';
            default:
                return 'Wählen Sie eine Gruppe.';
        }
    }

    get ausstallenActionLabel(): string {
        return this.selectedAction === 'umstallen_intern' ? 'Umstallen' : 'Ausstallen';
    }

    get ausstallenActionDescription(): string {
        if (this.selectedAction === 'umstallen_intern') {
            return 'Es wird eine Umstallliste für einen Transfer innerhalb Ihrer Betriebe angelegt. Anschließend können Sie Tiere zur Liste hinzufügen.';
        }
        return 'Es wird eine Ausstallliste für den Verkauf an einen externen Betrieb angelegt. Anschließend können Sie Tiere zur Liste hinzufügen.';
    }

    get embeddedAusstallenSubmitLabel(): string {
        return 'Liste abschliessen';
    }

    get last10SuccessfulScansCount(): number {
        return this.einstallenSubmitFlow.getLastSuccessfulScansCount(this.gewichtScans);
    }

    get last10ScansGesamtGewicht(): number {
        return this.einstallenSubmitFlow.getLastSuccessfulScansGesamtGewicht(this.gewichtScans);
    }

    get showLast10ScansGewicht(): boolean {
        return this.last10ScansGesamtGewicht > 0;
    }

    get missingGewichteCount(): number {
        return this.einstallenSubmitFlow.getMissingGewichtScans(this.gewichtScans).length;
    }

    get canSubmitMelden(): boolean {
        return this.einstallenSubmitFlow.canSubmitMelden(this.hitOptionen, this.overview);
    }

    get canOpenEinstallen(): boolean {
        return (
            this.localStorageService.hasPermission(PERMISSION_EINSTALLEN_PRIMARY) ||
            this.localStorageService.hasPermission(PERMISSION_EINSTALLEN_SECONDARY)
        );
    }

    canSelectAction(action: DashboardTierAction): boolean {
        if (action === 'einstallen') {
            return this.canOpenEinstallen;
        }
        if (action === 'sammelstelle') {
            return (
                this.localStorageService.canUseSammelstelle() &&
                isSammelstelleBetriebsart(this.selectedClient?.betriebsart_id)
            );
        }
        return this.hasClientChosen;
    }

    onClientSelected(client: Client): void {
        if (!client?.kunde_id) {
            return;
        }

        this.selectedClient = client;
        this.localStorageService.setCurrentClient(client, 'DashboardEinstallenStepperDialogComponent');
        this.resetWorkflowState(true);
        this.maxVisitedStepIndex = STEP_AKTION;
        this.loadGruppen();
        this.navigateToStep(STEP_AKTION);
    }

    waehleAktion(action: DashboardTierAction): void {
        if (!this.canSelectAction(action)) {
            return;
        }
        if (action === 'sammelstelle') {
            this.openSammelstelleDialog();
            return;
        }
        const actionChanged = this.selectedAction !== action;
        this.selectedAction = action;
        if (actionChanged) {
            this.resetWorkflowState(false);
        }
        if (this.isUmstallenIntern) {
            this.tierlisteMode = 'new';
        }
        if (this.gruppen.length === 0 && this.hasClientChosen) {
            this.loadGruppen();
        }
        if (this.stepper?.selectedIndex === this.ix.aktion) {
            setTimeout(() => {
                if (!this.stepper || this.stepper.selectedIndex !== this.ix.aktion) {
                    return;
                }
                const nextIx = this.showTierlisteAuswahlStep ? this.ix.tierlisteAuswahl : this.ix.gruppe;
                if (nextIx === null) {
                    return;
                }
                if (this.showTierlisteAuswahlStep) {
                    this.loadBestehendeTierlisten();
                }
                this.navigateToStep(nextIx, this.ix.aktion);
            }, 0);
        } else {
            setTimeout(() => this.refreshCompactStepNav(), 0);
        }
    }

    private openSammelstelleDialog(): void {
        const data: DashboardSammelstelleDialogData = {
            client: this.selectedClient ?? this.localStorageService.getCurrentClient(),
        };
        this.dialog.open(DashboardSammelstelleDialogComponent, {
            ...dashboardSammelstelleDialogLayout,
            data,
        });
        // Sammelstelle opens the Einstall stepper itself on "Einstallen" (avoids lost afterClosed).
        this.dialogRef.close(false);
    }

    openClientDialog(): void {
        if (!this.canChangeClient || this.isOpeningClientDialog) {
            return;
        }
        this.isOpeningClientDialog = true;
        this.changeCurrentClientService.openChangeDialog().subscribe({
            next: client => {
                this.isOpeningClientDialog = false;
                if (client?.kunde_id) {
                    this.onClientSelected(client);
                }
            },
            complete: () => {
                this.isOpeningClientDialog = false;
            },
        });
    }

    loadGruppen(moveToGroupStep = false, selectGruppeId?: number): void {
        if (!this.hasClientChosen) {
            return;
        }

        this.isLoadingGruppen = true;
        this.gruppenSubscription?.unsubscribe();

        let params = new HttpParams();
        if (this.selectedClient?.kunde_id) {
            params = params.set('kunde_id', this.selectedClient.kunde_id?.toString());
        }

        this.gruppenSubscription = this.api
            .getAll(this.apiBaseUrl + 'gruppe/read_akt_kundenportal.php', params)
            .pipe(finalize(() => (this.isLoadingGruppen = false)))
            .subscribe({
                next: response => {
                    this.gruppen = (response?.records || [])
                        .filter((gruppe: Gruppe) => isGruppeSichtbarFuerAusstallenUmstallen(gruppe))
                        .sort((a: Gruppe, b: Gruppe) => {
                            const tierDiff = Number(b?.anzahl_tiere_aktuell || 0) - Number(a?.anzahl_tiere_aktuell || 0);
                            if (tierDiff !== 0) {
                                return tierDiff;
                            }
                            return String(a?.bezeichnung || '').localeCompare(String(b?.bezeichnung || ''), 'de');
                        });
                    if (this.tierQuelleGlobal) {
                        this.refreshTierBrowseGruppeIds();
                    }
                    if (selectGruppeId && selectGruppeId > 0) {
                        const createdGruppe = this.gruppen.find(item => Number(item?.gruppe_id) === Number(selectGruppeId));
                        if (createdGruppe) {
                            this.waehleGruppe(createdGruppe);
                        }
                    }
                    if (moveToGroupStep && this.stepper) {
                        const gruppeIx = this.ix.gruppe;
                        this.navigateToStep(gruppeIx);
                    }
                },
                error: err => {
                    this.messageService.errorMessage('Fehler beim Laden der Gruppen!', err);
                },
            });
    }

    createNeueGruppe(): void {
        if (!this.selectedClient?.kunde_id || this.isLoadingGruppen || this.isLoadingGruppe) {
            return;
        }

        const input = new GruppeAnlegenDialogInput(this.selectedClient, true, '', null);
        this.dialog
            .open<GruppeAnlegenDialogComponent, GruppeAnlegenDialogInput, Gruppe>(GruppeAnlegenDialogComponent, {
                width: '95vw',
                maxWidth: '720px',
                data: input,
            })
            .afterClosed()
            .subscribe((createdGruppe: Gruppe | null) => {
                if (!createdGruppe?.gruppe_id) {
                    return;
                }
                this.loadGruppen(false, createdGruppe.gruppe_id);
            });
    }

    waehleTierQuelleGlobal(): void {
        if (!this.isAusstallenFlow || this.isLoadingGruppe) {
            return;
        }
        if (this.tierQuelleGlobal) {
            return;
        }
        this.tierQuelleGlobal = true;
        this.tierQuelleGruppeId = null;
        this.selectedGruppe = null;
        this.gruppe = null;
        this.refreshTierBrowseGruppeIds();
        this.tierauswahlAbgangsliste = null;
        this.ensureAusstallenInputBuilt();
        this.advanceAfterGruppeOrTierQuelleChosen();
    }

    waehleGruppe(gruppe: Gruppe): void {
        if (!gruppe?.gruppe_id || this.isLoadingGruppe) {
            return;
        }
        if (this.gruppe?.gruppe_id === gruppe.gruppe_id && !this.tierQuelleGlobal) {
            return;
        }

        this.tierQuelleGlobal = false;
        this.tierQuelleGruppeId = gruppe.gruppe_id;
        this.selectedGruppe = gruppe;
        this.refreshTierBrowseGruppeIds();
        this.isLoadingGruppe = true;
        this.gruppeSubscription?.unsubscribe();

        this.gruppeSubscription = this.gruppenService
            .getGruppeKundenportal(gruppe.gruppe_id)
            .pipe(finalize(() => (this.isLoadingGruppe = false)))
            .subscribe({
                next: loadedGruppe => {
                    if (!loadedGruppe?.gruppe_id) {
                        return;
                    }

                    this.gruppe = loadedGruppe;
                    if (this.isAusstallenFlow) {
                        this.tierauswahlAbgangsliste = null;
                        this.ensureAusstallenInputBuilt();
                    }
                    if (this.isEinstallenFlow) {
                        this.einstallenService.clearLastScanErgebnisse();
                        this.einstallenService.clearPendingGewichte();
                        this.einstallenService.clearCurrentEinstalldatum();
                        this.einstallenService.clearCurrentEinstallTierlisteId();
                        this.einstallenService.setCurrentGruppe(loadedGruppe);
                        this.overview = this.createEmptyOverview();
                        if (this.sammelstellePendingTiere.length > 0) {
                            this.flushSammelstellePendingAfterGruppeChosen(loadedGruppe);
                            return;
                        }
                        this.ensureEinstallTierliste(loadedGruppe);
                        this.recreateEinstallenOverview(true);
                    }
                    this.advanceAfterGruppeOrTierQuelleChosen();
                },
                error: err => {
                    this.messageService.errorMessage('Fehler beim Laden der Gruppe!', err);
                },
            });
    }

    private advanceAfterGruppeOrTierQuelleChosen(): void {
        if (this.currentStep !== this.ix.gruppe) {
            return;
        }
        setTimeout(() => {
            if (!this.stepper || this.currentStep !== this.ix.gruppe) {
                return;
            }
            const nextIx = this.isAusstallenFlow ? this.getAbgangStepAfterGruppe() : this.ix.workflowEinstallen;
            if (nextIx === null) {
                return;
            }
            this.navigateToStep(nextIx, this.ix.gruppe);
        }, 0);
    }

    stepChanged(event: StepperSelectionEvent): void {
        if (typeof event.selectedIndex !== 'number') {
            return;
        }
        this.applyStepIndexChange(event.selectedIndex, event.previouslySelectedIndex);
    }

    /** Sync state when the active step changes (stepper UI or compact nav). */
    private applyStepIndexChange(selectedIndex: number, _previousIndex?: number): void {
        this.currentStep = selectedIndex;
        this.maxVisitedStepIndex = Math.max(this.maxVisitedStepIndex, selectedIndex);

        if (selectedIndex === STEP_KUNDE && this.canChangeClient && !this.hasClientChosen) {
            setTimeout(() => {
                this.openClientDialog();
            }, 0);
        }

        if (
            selectedIndex === this.ix.gruppe &&
            this.hasClientChosen &&
            !this.isLoadingGruppen &&
            this.gruppen.length === 0
        ) {
            this.loadGruppen();
        }

        if (this.isUmstallenIntern && this.ix.zielbetrieb !== null && selectedIndex === this.ix.zielbetrieb) {
            this.initAbgangslisteForEmpfaengerOrZielbetriebStep();
        }

        if (
            this.showEmpfaengerStep &&
            this.ix.empfaenger !== null &&
            selectedIndex === this.ix.empfaenger
        ) {
            this.initAbgangslisteForEmpfaengerOrZielbetriebStep();
        }

        if (
            this.isAusstallenFlow &&
            this.showTiereAuswahlStep &&
            this.ix.tiereAuswahl !== null &&
            selectedIndex === this.ix.tiereAuswahl
        ) {
            this.initTierauswahlAbgangScan();
        }
        if (this.showTierlisteAuswahlStep && this.ix.tierlisteAuswahl !== null && selectedIndex === this.ix.tierlisteAuswahl) {
            this.refreshTierlistenOnListeStepEnter();
        }

        if (this.isEinstallenFlow && this.ix.review !== null && selectedIndex === this.ix.review) {
            this.loadReview();
        }

        if (this.isAusstallenFlow && this.ix.workflowAusstallen !== null && selectedIndex === this.ix.workflowAusstallen) {
            this.ensureAusstallenInputBuilt();
        }

        this.refreshCompactStepNav();
    }

    onEmbeddedTierlistePersisted(tierlisteId: number): void {
        this.tierlisteMenuCache.notifyChanged(tierlisteId);
    }

    onAusstallenFormSaved(result: AusstallenDialogResult): void {
        if (this.isAusstallenAbschliessenRunning) {
            return;
        }
        if (!result?.tierliste?.tierliste_id) {
            return;
        }
        void this.abschliessenEmbeddedAusstallen(result);
    }

    private async abschliessenEmbeddedAusstallen(prefilled?: AusstallenDialogResult): Promise<void> {
        if (this.isAusstallenAbschliessenRunning) {
            return;
        }
        const dlg = this.embeddedAusstallenDialog;
        const formTierliste = prefilled?.tierliste ?? dlg?.prepareForEmbeddedAbschluss() ?? null;
        if (!formTierliste?.tierliste_id) {
            return;
        }

        this.isAusstallenAbschliessenRunning = true;
        if (dlg) {
            dlg.isSaving = true;
        }
        try {
            if (dlg) {
                await dlg.persistKontakteIfNeeded();
                const weightsSaved = await dlg.persistAbgangsgewichteIfNeeded();
                if (!weightsSaved) {
                    return;
                }
            }

            let tierliste = this.buildTierlisteForAbschluss(formTierliste);
            tierliste = await this.refreshAbgangsTierlisteBeforeAbschluss(tierliste);

            const tiere = this.getTiereStillToAddToAbgangsliste(
                prefilled?.gruppenTiere ?? dlg?.getEmbeddedAbschlussTiere() ?? [],
            );
            if (tiere.length > 0) {
                const withTiere = await firstValueFrom(this.addSelectedTiereToTierliste(tierliste, tiere));
                tierliste = this.buildTierlisteForAbschluss({ ...tierliste, ...withTiere });
                tierliste = await this.refreshAbgangsTierlisteBeforeAbschluss(tierliste);
            }

            if (isTierlisteClosed(tierliste.status_id)) {
                this.completeAusstallenDashboard(tierliste, true);
                return;
            }

            tierliste = await this.persistTierlisteBeforeAbschluss(tierliste);
            tierliste = await this.refreshAbgangsTierlisteBeforeAbschluss(tierliste);

            const closed = await firstValueFrom(this.schliesseAbgangsliste(tierliste));
            dlg?.saveHitMeldenPreference();
            this.completeAusstallenDashboard(closed ?? tierliste, true);
        } catch (err) {
            this.messageService.errorMessage('Fehler beim Abschließen der Ausstallliste!', err);
        } finally {
            this.isAusstallenAbschliessenRunning = false;
            if (dlg) {
                dlg.isSaving = false;
            }
        }
    }

    /** Persist Ausstalldatum, Zielbetrieb, Kommentar (161) before status 162 close. */
    private persistTierlisteBeforeAbschluss(tierliste: Tierliste): Promise<Tierliste> {
        const payload: Tierliste = this.ohneUnveraendertenKommentar({
            ...tierliste,
            status_id: 161,
            haendler_uebernehmen: 0,
        });
        const formattedDatum = this.formatTierlisteDatumForApi(payload.datum_abgang);
        if (formattedDatum) {
            payload.datum_abgang = formattedDatum as unknown as Date;
        }
        return firstValueFrom(
            this.api.post(this.apiBaseUrl + 'tierliste/update_kundenportal.php', payload, undefined).pipe(
                map(res => this.buildTierlisteForAbschluss({ ...tierliste, ...(res ?? payload) })),
                catchError(() => of(tierliste)),
            ),
        );
    }

    private refreshAbgangsTierlisteBeforeAbschluss(tierliste: Tierliste): Promise<Tierliste> {
        const id = Number(tierliste?.tierliste_id || 0);
        if (id <= 0) {
            return Promise.resolve(tierliste);
        }
        const formDatum =
            this.formatTierlisteDatumForApi(this.embeddedAusstallenDialog?.datumCtrl?.value) ??
            this.formatTierlisteDatumForApi(tierliste.datum_abgang);
        const formKommentar = this.formKommentarForAbschluss();
        const formGewichtGesamtAbgang = this.embeddedAusstallenDialog?.tierliste?.gewicht_gesamt_abgang
            ?? tierliste.gewicht_gesamt_abgang;
        const abgangMeldenFromForm = tierliste.abgang_melden;
        const dlgHit = this.embeddedAusstallenDialog?.hitMeldenCtrl?.value;
        return firstValueFrom(
            this.api
                .getByIdAlternative(
                    this.apiBaseUrl + 'tierliste/read_one_kundenportal.php',
                    'tierliste_id',
                    String(id),
                )
                .pipe(
                    map(fresh => {
                        const merged = { ...tierliste, ...fresh };
                        if (formDatum) {
                            merged.datum_abgang = formDatum as unknown as Date;
                        }
                        if (formKommentar !== undefined) {
                            merged.kommentar = formKommentar;
                        }
                        if (formGewichtGesamtAbgang != null && formGewichtGesamtAbgang !== undefined) {
                            merged.gewicht_gesamt_abgang = formGewichtGesamtAbgang;
                        }
                        // Keep HIT choice from form/dialog — DB still has 0 until status-162 close
                        if (abgangMeldenFromForm !== undefined && abgangMeldenFromForm !== null) {
                            merged.abgang_melden = abgangMeldenFromForm;
                        }
                        if (
                            this.embeddedAusstallenDialog &&
                            !this.embeddedAusstallenDialog.istDerselbeKunde() &&
                            dlgHit !== undefined &&
                            dlgHit !== null
                        ) {
                            merged.abgang_melden = Number(dlgHit);
                        }
                        const gewichteFromForm = this.gewichteImportierenFromForm();
                        if (gewichteFromForm !== undefined) {
                            merged.gewichte_importieren = gewichteFromForm;
                        }
                        return this.buildTierlisteForAbschluss(merged);
                    }),
                    catchError(() => of(this.buildTierlisteForAbschluss(tierliste))),
                ),
        );
    }

    onAusstallenFormAborted(): void {
        if (this.isContinueAbgangAtAusstallenStep) {
            this.close();
            return;
        }
        this.stepper?.previous();
    }

    private finishAusstallenFlow(tierliste: Tierliste): void {
        if (!tierliste?.tierliste_id) {
            return;
        }
        if (isTierlisteClosed(tierliste.status_id)) {
            this.completeAusstallenDashboard(tierliste);
            return;
        }
        this.schliesseAbgangsliste(tierliste).subscribe({
            next: closedListe => this.completeAusstallenDashboard(closedListe, true),
            error: err => this.messageService.errorMessage('Fehler beim Abschließen der Ausstallliste!', err),
        });
    }

    private completeAusstallenDashboard(tierliste: Tierliste, showAbschliessenMessage = false): void {
        const merged = this.buildTierlisteForAbschluss(tierliste);
        const wasUmstallenIntern = this.selectedAction === 'umstallen_intern';
        this.abgangTierliste = merged;
        this.tierauswahlAbgangsliste = merged;
        this.anzahlTiereInAbgangListe = Number(merged.anzahl_tiere ?? 0);
        this.syncAbgangServiceListe(merged);
        if (showAbschliessenMessage) {
            this.messageService.infoMessage(
                wasUmstallenIntern
                    ? 'Die Umstallliste wurde erfolgreich abgeschlossen!'
                    : 'Die Ausstallliste wurde erfolgreich abgeschlossen!',
            );
        }

        this.dialogRef
            .afterClosed()
            .pipe(take(1))
            .subscribe(() => {
                if (wasUmstallenIntern) {
                    this.ausstallenService.triggerInternalImportIfEligible(merged);
                }
                this.abgangService.tierListeAbgeschlossen(merged, 'dashboardAusstallenFlow');
                if (merged.gruppe_id_abgang) {
                    this.abgangService.gruppeAktualisieren(merged.gruppe_id_abgang);
                }
            });
        this.dialogRef.close(true);
    }

    /** Same close payload as AbgangslisteSchliessenDialog (status 162). */
    private schliesseAbgangsliste(tierliste: Tierliste): Observable<Tierliste> {
        const payload: Tierliste = { ...tierliste };
        payload.status_id = 162;
        payload.haendler_uebernehmen = 0;
        const istDerselbeKunde =
            resolveTierlisteExtern(payload, this.gruppe?.kunde_id) === 0;
        payload.tierliste_extern = resolveTierlisteExtern(payload, this.gruppe?.kunde_id);

        return forkJoin({
            hitMelden: this.api.getSpeicher('hit_melden').pipe(catchError(() => of(1))),
            gleicheUnternehmensgruppe: this.stammdatenService
                .istBetriebInKundenportal(Number(payload.kunde_id_einstallen || 0))
                .pipe(catchError(() => of(false))),
        }).pipe(
            switchMap(({ hitMelden, gleicheUnternehmensgruppe }) => {
                if (istDerselbeKunde) {
                    payload.abgang_melden = 0;
                } else {
                    const dlgHit = this.embeddedAusstallenDialog?.hitMeldenCtrl?.value;
                    if (dlgHit !== undefined && dlgHit !== null) {
                        payload.abgang_melden = Number(dlgHit);
                    } else if (payload.abgang_melden === undefined || payload.abgang_melden === null) {
                        payload.abgang_melden =
                            hitMelden != null && hitMelden !== undefined ? Number(hitMelden) : 1;
                    } else {
                        payload.abgang_melden = Number(payload.abgang_melden);
                    }
                }

                payload.import_einstallen = payload.kunde_id_einstallen ? 1 : 0;

                const gewichteFromForm = this.gewichteImportierenFromForm();
                if (gewichteFromForm !== undefined) {
                    payload.gewichte_importieren = gewichteFromForm;
                }

                const umstallenIntern = this.selectedAction === 'umstallen_intern';
                if ((umstallenIntern || gleicheUnternehmensgruppe) && payload.kunde_id_einstallen) {
                    payload.reklamationen_weitergeben = 1;
                } else {
                    payload.reklamationen_weitergeben = 0;
                }

                const formattedDatum = this.formatTierlisteDatumForApi(payload.datum_abgang);
                if (formattedDatum) {
                    payload.datum_abgang = formattedDatum as unknown as Date;
                }
                payload.abgang_melden = Number(payload.abgang_melden ?? 0);
                payload.import_einstallen = Number(payload.import_einstallen ?? 0);
                payload.gewichte_importieren = Number(payload.gewichte_importieren ?? 0);
                payload.reklamationen_weitergeben = Number(payload.reklamationen_weitergeben ?? 0);

                return this.api.post(
                    this.apiBaseUrl + 'tierliste/update_kundenportal.php',
                    this.ohneUnveraendertenKommentar(payload),
                    undefined,
                );
            }),
            map((response: Tierliste) => ({ ...payload, ...(response ?? {}) })),
        );
    }

    isAusstallenTierSelected(gtId: number): boolean {
        return this.selectedAusstallenTierIds.has(Number(gtId));
    }

    toggleAusstallenTier(gtId: number, selected: boolean): void {
        const parsedGtId = Number(gtId);
        if (parsedGtId <= 0) {
            return;
        }
        if (selected) {
            this.selectedAusstallenTierIds.add(parsedGtId);
        } else {
            this.selectedAusstallenTierIds.delete(parsedGtId);
        }
        this.ensureAusstallenInputBuilt();
    }

    toggleAllAusstallenTiere(selected: boolean): void {
        this.selectedAusstallenTierIds.clear();
        if (selected) {
            for (const tier of this.filteredAusstallenTierKandidaten) {
                const gtId = Number(tier?.gt_id);
                if (gtId > 0) {
                    this.selectedAusstallenTierIds.add(gtId);
                }
            }
        }
        this.ensureAusstallenInputBuilt();
    }

    toggleAllVisibleAusstallenTiere(): void {
        this.toggleAllAusstallenTiere(!this.areAllVisibleAusstallenTiereSelected);
    }

    private continueFromTierauswahl(): void {
        if (!this.hasTierauswahlForAusstallen) {
            return;
        }
        if (this.tierauswahlAbgangsliste) {
            this.abgangTierliste = this.tierauswahlAbgangsliste;
        }
        this.ensureAusstallenInputBuilt();
        const nextIx = this.ix.workflowAusstallen;
        if (nextIx === null || !this.stepper) {
            return;
        }
        this.navigateToStep(nextIx);
    }

    private getAbgangStepAfterGruppe(): number | null {
        if (this.showEmpfaengerStep && this.ix.empfaenger !== null) {
            return this.ix.empfaenger;
        }
        if (this.showZielbetriebStep && this.ix.zielbetrieb !== null) {
            return this.ix.zielbetrieb;
        }
        return this.ix.tiereAuswahl;
    }

    continueFromEmpfaengerOrZielbetriebStep(): void {
        const nextIx = this.ix.tiereAuswahl;
        if (nextIx === null || !this.stepper) {
            return;
        }
        this.navigateToStep(nextIx);
    }

    applyEmpfaengerDialogResult(result: AusstallenEmpfaengerDialogResult): void {
        this.empfaengerSchlachthof = result.schlachthof ?? null;
        this.empfaengerKontakte = result.kontakte ?? [];
        this.applyWorkingAbgangsTierliste(result.tierliste);
        this.rebuildEmpfaengerDisplayEntries();
        this.ensureAusstallenInputBuilt();
        this.refreshCompactStepNav();
        this.cdr.markForCheck();
        if (this.pendingEmpfaengerStepAdvance) {
            this.pendingEmpfaengerStepAdvance = false;
            this.continueFromEmpfaengerOrZielbetriebStep();
        }
    }

    applyZielbetriebDialogResult(result: AusstallenEmpfaengerDialogResult): void {
        this.selectedZielbetrieb = result.zielbetrieb ?? null;
        this.applyWorkingAbgangsTierliste(result.tierliste);
        const tierlisteId = Number(result.tierliste?.tierliste_id);
        if (tierlisteId > 0) {
            this.tierlisteMenuCache.notifyChanged(tierlisteId);
        }
        this.ensureAusstallenInputBuilt();
        this.refreshCompactStepNav();
        this.cdr.markForCheck();
        if (this.pendingZielbetriebStepAdvance) {
            this.pendingZielbetriebStepAdvance = false;
            this.continueFromEmpfaengerOrZielbetriebStep();
        }
    }

    private persistEmpfaengerFromEmbeddedStepper(): void {
        const picker = this.embeddedEmpfaengerPicker;
        if (!picker?.canSubmit || picker.isSaving) {
            return;
        }
        this.pendingEmpfaengerStepAdvance = true;
        picker.save();
    }

    private persistZielbetriebFromEmbeddedStepper(): void {
        const picker = this.embeddedZielbetriebPicker;
        if (!picker?.canSubmit || picker.isSaving) {
            return;
        }
        this.pendingZielbetriebStepAdvance = true;
        picker.save();
    }

    getStepperInhaberKundeId(): number | null {
        return Number(this.gruppe?.kunde_id ?? this.selectedClient?.kunde_id) || null;
    }

    private rebuildEmpfaengerDisplayEntries(): void {
        const liste = this.getWorkingAbgangsTierliste();
        this.empfaengerDisplayEntries = getExternEmpfaengerDisplayEntries(
            liste,
            this.empfaengerKontakte,
            this.empfaengerSchlachthof,
        );
    }

    private prefillEmpfaengerFromWorkingTierliste(): void {
        const liste = this.getWorkingAbgangsTierliste();
        if (!liste?.tierliste_id || !this.isAusstallenExtern) {
            return;
        }
        if (liste.kunde_id_schlachthof) {
            this.empfaengerSchlachthof = new Client();
            this.empfaengerSchlachthof.kunde_id = liste.kunde_id_schlachthof;
            this.empfaengerSchlachthof.bezeichnung = liste.kunde_schlachthof;
            this.empfaengerSchlachthof.zusatz = liste.kunde_zusatz_schlachthof;
            this.empfaengerSchlachthof.vvvo = liste.kunde_vvvo_schlachthof;
            this.empfaengerSchlachthof.strasse = liste.kunde_strasse_schlachthof;
            this.empfaengerSchlachthof.plz = liste.kunde_plz_schlachthof;
            this.empfaengerSchlachthof.ort = liste.kunde_ort_schlachthof;
        }
        const tierlisteId = Number(liste.tierliste_id);
        if (this.empfaengerPrefillTierlisteId === tierlisteId && this.empfaengerPrefillSubscription && !this.empfaengerPrefillSubscription.closed) {
            return;
        }
        this.empfaengerPrefillTierlisteId = tierlisteId;
        this.empfaengerPrefillSubscription?.unsubscribe();
        this.empfaengerPrefillSubscription = this.bbtService.getVerbindungenFuerTierliste(liste.tierliste_id).subscribe({
            next: result => {
                const aktive = filterAktiveBetriebskontakteTierlisteVerbindungen(
                    unwrapBetriebskontakteTierlisteReadResponse(result),
                );
                this.empfaengerKontakte = mapBetriebskontakteTierlisteVerbindungenToKontakte(aktive);
                this.rebuildEmpfaengerDisplayEntries();
                this.cdr.markForCheck();
            },
            error: () => {
                this.empfaengerPrefillTierlisteId = 0;
                this.rebuildEmpfaengerDisplayEntries();
            },
        });
    }

    private initAbgangslisteForEmpfaengerOrZielbetriebStep(): void {
        if (!this.isAusstallenFlow || !this.hasTierlisteChoice || !this.canPrepareTierauswahlAbgang()) {
            return;
        }
        const working = this.getWorkingAbgangsTierliste();
        if (working?.tierliste_id) {
            if (!this.tierauswahlAbgangsliste?.tierliste_id) {
                this.tierauswahlAbgangsliste = working;
                this.abgangTierliste = working;
                this.syncAbgangServiceListe(working);
            }
            if (this.isAusstallenExtern) {
                this.prefillEmpfaengerFromWorkingTierliste();
            }
            this.cdr.markForCheck();
            return;
        }
        this.initTierauswahlAbgangScan();
    }

    waehleTierlisteMode(mode: 'new' | 'existing'): void {
        this.tierlisteMode = mode;
        if (mode === 'new') {
            this.selectedBestehendeTierliste = null;
            this.resetTierQuelleForAbgang();
            this.ensureAusstallenInputBuilt();
            this.advanceFromTierlisteAuswahl();
            return;
        }
        if (this.needsTierlistenReload() && !this.isLoadingBestehendeTierlisten) {
            this.loadBestehendeTierlisten();
        }
        this.ensureAusstallenInputBuilt();
    }

    waehleBestehendeTierliste(tierliste: Tierliste): void {
        if (!tierliste?.tierliste_id) {
            return;
        }
        this.selectedBestehendeTierliste = tierliste;
        this.tierlisteMode = 'existing';
        this.resetTierQuelleForAbgang();
        this.ensureAusstallenInputBuilt();
        this.advanceFromTierlisteAuswahl();
    }

    continueFromTierlisteAuswahl(): void {
        this.advanceFromTierlisteAuswahl();
    }

    private advanceFromTierlisteAuswahl(): void {
        if (!this.hasTierlisteChoice) {
            return;
        }
        const nextIx = this.ix.gruppe;
        if (nextIx === null || !this.stepper) {
            return;
        }
        if (!this.isLoadingGruppen && this.gruppen.length === 0 && this.hasClientChosen) {
            this.loadGruppen();
        }
        setTimeout(() => {
            if (!this.stepper || this.ix.tierlisteAuswahl === null) {
                return;
            }
            if (this.stepper.selectedIndex !== this.ix.tierlisteAuswahl) {
                return;
            }
            this.navigateToStep(nextIx, this.ix.tierlisteAuswahl ?? undefined);
        }, 0);
    }

    abschliessenAbgangListe(): void {
        const tierliste = this.getWorkingAbgangsTierliste();
        if (!tierliste?.tierliste_id || isTierlisteClosed(tierliste.status_id)) {
            return;
        }
        this.schliesseAbgangsliste(tierliste).subscribe({
            next: closedListe => this.completeAusstallenDashboard(closedListe, true),
            error: err => this.messageService.errorMessage('Fehler beim Abschließen der Ausstallliste!', err),
        });
    }

    isSameKundeId(
        a: { kunde_id?: unknown } | null | undefined,
        b: { kunde_id?: unknown } | null | undefined,
    ): boolean {
        return KieneUtils.sameId(a?.kunde_id, b?.kunde_id);
    }

    goToReview(): void {
        if (!this.hasGruppeChosen || this.ix.review == null) {
            return;
        }

        this.loadReview();
        this.navigateToStep(this.ix.review);
    }

    gewichteBearbeiten(): void {
        if (!this.gruppe?.gruppe_id) {
            return;
        }

        this.einstallenSubmitFlow
            .openGewichteDialog(this.gruppe.gruppe_id, this.gewichtScans)
            .subscribe(saved => {
            if (saved) {
                this.loadReview();
            }
        });
    }

    submit(): void {
        if (!this.gruppe?.gruppe_id || this.isSubmitting || this.isClosingTierliste) {
            return;
        }

        const submitInput = this.einstallenSubmitFlow.buildMeldenSubmitInput(this.hitOptionen, this.gruppe);
        if (!submitInput.gruppeId || !this.einstallenSubmitFlow.canSubmitMelden(this.hitOptionen, this.overview)) {
            return;
        }

        const einstallTierlisteId = submitInput.einstallTierlisteId;
        this.isSubmitting = true;
        this.einstallenSubmitFlow
            .submitHitMelden(submitInput)
            .then(saved => {
                if (saved) {
                    if (einstallTierlisteId) {
                        this.tierlisteMenuCache.notifyChanged(einstallTierlisteId);
                    }
                    this.dialogRef.close(true);
                }
            })
            .catch(err => {
                this.messageService.errorMessage('Fehler beim Melden der Tiere!', err);
            })
            .finally(() => {
                this.isSubmitting = false;
            });
    }

    abschliessen(): void {
        if (!this.gruppe?.gruppe_id || this.isSubmitting || this.isClosingTierliste) {
            return;
        }

        const submitInput = this.einstallenSubmitFlow.buildMeldenSubmitInput(this.hitOptionen, this.gruppe);
        const einstallTierlisteId = submitInput.einstallTierlisteId;
        this.isClosingTierliste = true;
        this.einstallenSubmitFlow
            .closeEinstallTierlisteWithoutMelden({
                gruppeId: submitInput.gruppeId,
                gsId: submitInput.gsId,
                einstallTierlisteId,
            })
            .then(closed => {
                if (closed) {
                    if (einstallTierlisteId) {
                        this.tierlisteMenuCache.notifyChanged(einstallTierlisteId);
                    }
                    this.dialogRef.close(true);
                }
            })
            .catch(err => {
                this.messageService.errorMessage('Fehler beim Abschliessen der Liste!', err);
            })
            .finally(() => {
                this.isClosingTierliste = false;
            });
    }

    close(): void {
        this.dialogRef.close(false);
    }

    getClientDisplay(client: Client): string {
        if (!client) {
            return '';
        }

        const parts = [client.vvvo, client.bezeichnung_final, client.zusatz_final].filter(part => !!part);
        return parts.join(' | ');
    }

    private loadReview(): void {
        if (!this.gruppe?.gruppe_id) {
            return;
        }

        this.isLoadingReview = true;
        this.reviewSubscription?.unsubscribe();
        this.reviewSubscription = this.einstallenSubmitFlow
            .ensureFullTierlisteForReview(
                this.gruppe.gruppe_id,
                this.einstallenService.getCurrentEinstallTierlisteId(),
            )
            .pipe(
                switchMap(() =>
                    forkJoin({
                        overview: this.einstallenSubmitFlow.loadMeldenOverview(
                            this.gruppe.gruppe_id,
                            this.einstallenSubmitFlow.getEinstallMeldenOverviewOptions(
                                this.einstallenService.getCurrentEinstallTierlisteId(),
                            ),
                        ),
                        gewichtScans: this.einstallenSubmitFlow.loadGewichtRelevantScans(
                            this.gruppe.gruppe_id,
                            this.einstallenService.getCurrentEinstallTierlisteId(),
                        ),
                    }),
                ),
                finalize(() => (this.isLoadingReview = false)),
            )
            .subscribe({
                next: ({ overview, gewichtScans }) => {
                    this.overview = overview;
                    this.hitOptionen = this.einstallenSubmitFlow.deriveHitOptionenFromOverview(overview);
                    this.gewichtScans = gewichtScans;
                },
                error: err => {
                    this.messageService.errorMessage('Fehler beim Laden!', err);
                },
            });
    }

    private recreateEinstallenOverview(forceRecreate = false): void {
        const shouldShow = !!this.gruppe?.gruppe_id;
        if (!forceRecreate) {
            this.showEinstallenOverview = shouldShow;
            return;
        }
        this.showEinstallenOverview = false;
        setTimeout(() => {
            this.showEinstallenOverview = shouldShow;
        }, 0);
    }

    /** Hide loading overlay only after stepper + step content are in the DOM (avoids mount blink). */
    private completePrefillInitialization(): void {
        if (this.prefillInitializationDone) {
            return;
        }
        this.prefillInitializationDone = true;
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.isLoadingGruppe = false;
                this.cdr.detectChanges();
            });
        });
    }

    private ensureEinstallTierliste(gruppe: Gruppe): void {
        if (!gruppe?.gruppe_id || this.einstallenService.getCurrentEinstallTierlisteId()) {
            return;
        }
        this.einstallenService
            .createEinstallTierliste(gruppe.gruppe_id, gruppe.kunde_id ?? this.selectedClient?.kunde_id ?? null)
            .subscribe({
                next: res => {
                    const tierlisteId = Number(res?.tierliste_id || 0);
                    if (tierlisteId > 0) {
                        this.einstallenService.setCurrentEinstallTierlisteId(tierlisteId);
                    }
                },
                error: err => {
                    this.messageService.errorMessage('Einstall-Tierliste konnte nicht erstellt werden!', err);
                },
            });
    }

    private initContinueDirectScan(): void {
        const cfg = this.dialogData?.continueDirectScan;
        const gruppeId = Number(cfg?.gruppeId || 0);
        const prefillTiere = this.normalizePrefillTiere(cfg?.prefillTiere, cfg?.prefillOhrmarken);
        const allowSammelstellePrefill =
            prefillTiere.length > 0 && this.localStorageService.canUseSammelstelle();
        if (gruppeId <= 0 || (!this.canOpenEinstallen && !allowSammelstellePrefill)) {
            this.isLoadingGruppe = false;
            this.messageService.errorMessage('Scans können nicht fortgesetzt werden.', null);
            return;
        }

        this.selectedAction = 'einstallen';
        this.isLoadingGruppe = true;
        this.prefillInitializationDone = false;
        this.continueDirectScanSubscription?.unsubscribe();

        const resolveTierlisteId$ =
            Number(cfg?.einstallTierlisteId || 0) > 0
                ? of(Number(cfg.einstallTierlisteId))
                : this.einstallenService.createEinstallTierliste(gruppeId, cfg?.kundeId ?? null).pipe(
                      map(res => Number(res?.tierliste_id || 0)),
                      switchMap(tierlisteId =>
                          tierlisteId > 0
                              ? of(tierlisteId)
                              : throwError(() => new Error('Einstall-Tierliste konnte nicht erstellt werden')),
                      ),
                  );

        this.continueDirectScanSubscription = resolveTierlisteId$
            .pipe(
                tap(einstallTierlisteId => {
                    cfg.einstallTierlisteId = einstallTierlisteId;
                    this.einstallenService.setCurrentEinstallTierlisteId(einstallTierlisteId);
                }),
                switchMap(einstallTierlisteId => {
                    const createPrefill$ =
                        prefillTiere.length > 0
                            ? this.createPrefillTiereOnTierliste({
                                  gruppeId,
                                  tierlisteId: einstallTierlisteId,
                                  tiere: prefillTiere,
                                  kundeId: cfg?.kundeId ?? null,
                                  kpEinstalldatum: cfg?.kp_einstalldatum ?? null,
                              })
                            : of([] as ScanErgebnis[]);
                    return createPrefill$.pipe(
                        map(createdScans => ({ einstallTierlisteId, createdScans })),
                    );
                }),
                switchMap(({ einstallTierlisteId, createdScans }) => {
                    const params = new HttpParams()
                        .set('gruppe_id', String(gruppeId))
                        .set('einstall_tierliste_id', String(einstallTierlisteId))
                        .set('for_continue_scan', '1');
                    const tierlisteParams = new HttpParams().set('tierliste_id', String(einstallTierlisteId));
                    return this.gruppenService.getGruppeKundenportal(gruppeId).pipe(
                        switchMap(loadedGruppe => {
                            if (!loadedGruppe?.gruppe_id) {
                                return throwError(() => new Error('Gruppe nicht gefunden'));
                            }
                            const kundeId = Number(cfg?.kundeId || loadedGruppe.kunde_id) || 0;
                            return this.ensureClientForContinueScan(kundeId).pipe(map(() => loadedGruppe));
                        }),
                        switchMap(loadedGruppe => {
                            this.gruppe = loadedGruppe;
                            this.selectedGruppe = loadedGruppe;
                            this.tierQuelleGruppeId = loadedGruppe.gruppe_id;
                            this.refreshTierBrowseGruppeIds();
                            this.einstallenService.setCurrentGruppe(loadedGruppe);
                            this.showEinstallenOverview = true;
                            return forkJoin({
                                tiere: this.api.getAll(
                                    this.apiBaseUrl + 'gruppe/read_tiere_fuer_letzte_aktion.php',
                                    params,
                                ),
                                tierliste: this.api.get(
                                    this.apiBaseUrl + 'tierliste/read_one_kundenportal.php',
                                    tierlisteParams,
                                ),
                            }).pipe(map(loaded => ({ ...loaded, createdScans })));
                        }),
                    );
                }),
            )
            .subscribe({
                next: ({ tiere, tierliste, createdScans }) => {
                    const fromApi = this.mapContinueScanRecords(tiere?.records || []);
                    const scans = fromApi.length > 0 ? fromApi : createdScans || [];
                    this.einstallenService.setLastScanErgebnisse(scans);
                    this.applyContinueDirectScanPrefill(tierliste);
                    this.applySammelstellePrefillDatum(cfg?.kp_einstalldatum);
                    this.loadGruppen();
                    this.finalizeContinueDirectScanSetup();
                },
                error: err => {
                    this.isLoadingGruppe = false;
                    this.messageService.errorMessage('Fehler beim Fortsetzen der Scans!', err);
                },
            });
    }

    /** Select the Betrieb from the action's group when dashboard has no Kunde filter yet. */
    private ensureClientForContinueScan(kundeId: number): Observable<Client> {
        const normalizedKundeId = Number(kundeId) || 0;
        if (normalizedKundeId <= 0) {
            return throwError(() => new Error('Kunde nicht gefunden'));
        }

        const currentClient = this.selectedClient ?? this.localStorageService.getCurrentClient();
        if (Number(currentClient?.kunde_id) === normalizedKundeId) {
            this.selectedClient = currentClient;
            return of(currentClient);
        }

        const params = new HttpParams().set('kunde_id', String(normalizedKundeId));
        return this.api.get(this.apiBaseUrl + 'kunde/read_one_kundenportal.php', params).pipe(
            map((kunde: Client) => {
                if (!kunde?.kunde_id) {
                    throw new Error('Kunde nicht gefunden');
                }
                this.selectedClient = kunde;
                this.localStorageService.setCurrentClient(
                    kunde,
                    'DashboardEinstallenStepperDialogComponent.continueDirectScan',
                );
                return kunde;
            }),
        );
    }

    private applyContinueDirectScanPrefill(tierliste: Tierliste | null | undefined): void {
        if (tierliste?.datum_einstallen) {
            const parsed = new Date(tierliste.datum_einstallen);
            if (!isNaN(parsed.getTime())) {
                this.einstallenService.setCurrentEinstalldatum(parsed);
            }
        }
    }

    private captureSammelstellePendingFromDialogData(): void {
        const cfg = this.dialogData?.sammelstellePrefill;
        this.sammelstellePendingTiere = this.normalizePrefillTiere(
            cfg?.prefillTiere,
            cfg?.prefillOhrmarken,
        );
        this.sammelstellePendingDatum = cfg?.kp_einstalldatum
            ? String(cfg.kp_einstalldatum).trim() || null
            : null;
    }

    private initSammelstellePrefillWithoutGruppe(): void {
        this.captureSammelstellePendingFromDialogData();
        if (!this.sammelstellePendingTiere.length) {
            return;
        }
        this.selectedAction = 'einstallen';
        const kundeId =
            Number(this.dialogData?.sammelstellePrefill?.kundeId || 0) ||
            Number(this.selectedClient?.kunde_id || 0);

        const goToGruppeAndLoad = () => {
            this.loadGruppen();
            this.navigateToSammelstelleGruppeStep(0);
        };

        if (kundeId > 0) {
            this.sammelstellePrefillSubscription?.unsubscribe();
            this.sammelstellePrefillSubscription = this.ensureClientForContinueScan(kundeId).subscribe({
                next: () => goToGruppeAndLoad(),
                error: err => {
                    this.messageService.errorMessage('Kunde konnte nicht geladen werden.', err);
                    setTimeout(() => this.navigateToStep(STEP_KUNDE, this.stepper?.selectedIndex), 0);
                },
            });
            return;
        }
        if (!this.hasClientChosen && this.canChangeClient) {
            setTimeout(() => this.openClientDialog(), 0);
            return;
        }
        goToGruppeAndLoad();
    }

    /** Retry until Material stepper exists, then open Gruppe (pending Ohrmarken stay in memory). */
    private navigateToSammelstelleGruppeStep(attempt: number): void {
        setTimeout(() => {
            const gruppeIx = this.ix.gruppe;
            if (gruppeIx == null || !this.stepper?.steps?.length) {
                if (attempt < 12) {
                    this.navigateToSammelstelleGruppeStep(attempt + 1);
                }
                return;
            }
            this.maxVisitedStepIndex = Math.max(this.maxVisitedStepIndex, gruppeIx);
            const from = this.stepper.selectedIndex;
            this.navigateToStep(gruppeIx, from);
            this.refreshCompactStepNav();
            this.cdr.detectChanges();
            // If Material still did not move, retry once more.
            if (this.stepper.selectedIndex !== gruppeIx && attempt < 12) {
                this.navigateToSammelstelleGruppeStep(attempt + 1);
            }
        }, attempt === 0 ? 0 : 40);
    }

    private flushSammelstellePendingAfterGruppeChosen(loadedGruppe: Gruppe): void {
        const tiere = [...this.sammelstellePendingTiere];
        const datum = this.sammelstellePendingDatum;
        const gruppeId = Number(loadedGruppe.gruppe_id);
        const kundeId =
            Number(loadedGruppe.kunde_id) ||
            Number(this.selectedClient?.kunde_id) ||
            Number(this.dialogData?.sammelstellePrefill?.kundeId) ||
            null;

        // waehleGruppe finalize clears isLoadingGruppe after this next() returns — reassert.
        setTimeout(() => {
            this.isLoadingGruppe = true;
            this.cdr.detectChanges();
        }, 0);

        this.sammelstellePrefillSubscription?.unsubscribe();
        this.sammelstellePrefillSubscription = this.einstallenService
            .ensureEinstallTierliste(gruppeId, kundeId, true)
            .pipe(
                switchMap(tierlisteId =>
                    this.createPrefillTiereOnTierliste({
                        gruppeId,
                        tierlisteId,
                        tiere,
                        kundeId,
                        kpEinstalldatum: datum,
                    }).pipe(map(createdScans => ({ tierlisteId, createdScans }))),
                ),
                switchMap(({ tierlisteId, createdScans }) => {
                    const params = new HttpParams()
                        .set('gruppe_id', String(gruppeId))
                        .set('einstall_tierliste_id', String(tierlisteId))
                        .set('for_continue_scan', '1');
                    return this.api
                        .getAll(this.apiBaseUrl + 'gruppe/read_tiere_fuer_letzte_aktion.php', params)
                        .pipe(map(tiereRes => ({ tiere: tiereRes, createdScans })));
                }),
                finalize(() => {
                    this.isLoadingGruppe = false;
                }),
            )
            .subscribe({
                next: ({ tiere: tiereRes, createdScans }) => {
                    this.sammelstellePendingTiere = [];
                    this.sammelstellePendingDatum = null;
                    const fromApi = this.mapContinueScanRecords(tiereRes?.records || []);
                    const scans = fromApi.length > 0 ? fromApi : createdScans || [];
                    this.einstallenService.setLastScanErgebnisse(scans);
                    this.applySammelstellePrefillDatum(datum);
                    this.showEinstallenOverview = true;
                    this.recreateEinstallenOverview(true);
                    this.navigateToEinstallenAfterSammelstellePrefill();
                },
                error: err => {
                    this.messageService.errorMessage(
                        'Nicht gefundene Tiere konnten nicht eingestallt werden.',
                        err,
                    );
                    this.ensureEinstallTierliste(loadedGruppe);
                    this.recreateEinstallenOverview(true);
                    this.advanceAfterGruppeOrTierQuelleChosen();
                },
            });
    }

    private navigateToEinstallenAfterSammelstellePrefill(): void {
        setTimeout(() => {
            const einstallIx = this.ix.workflowEinstallen;
            if (einstallIx != null) {
                this.maxVisitedStepIndex = Math.max(
                    this.maxVisitedStepIndex,
                    einstallIx,
                    this.ix.review ?? einstallIx,
                );
                this.navigateToStep(einstallIx);
            } else {
                this.advanceAfterGruppeOrTierQuelleChosen();
            }
            this.refreshCompactStepNav();
        }, 0);
    }

    private normalizePrefillTiere(
        tiere: DashboardSammelstellePrefillTier[] | null | undefined,
        ohrmarkenFallback?: string[] | null,
    ): DashboardSammelstellePrefillTier[] {
        const seen = new Set<string>();
        const out: DashboardSammelstellePrefillTier[] = [];
        const push = (draft: DashboardSammelstellePrefillTier) => {
            const digits = normalizeOhrmarkePassScanInput(String(draft?.ohrmarke ?? ''));
            if (!isValidOhrmarkePassScanLength(digits) || seen.has(digits)) {
                return;
            }
            seen.add(digits);
            out.push({ ...draft, ohrmarke: digits });
        };
        for (const t of tiere || []) {
            push(t);
        }
        if (!out.length) {
            for (const raw of ohrmarkenFallback || []) {
                push({ ohrmarke: String(raw ?? '') });
            }
        }
        return out;
    }

    private applySammelstellePrefillDatum(raw: string | null | undefined): void {
        const value = String(raw ?? '').trim();
        if (!value) {
            return;
        }
        const iso = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (!iso) {
            return;
        }
        const parsed = new Date(Number(iso[1]), Number(iso[2]) - 1, Number(iso[3]));
        if (Number.isNaN(parsed.getTime())) {
            return;
        }
        parsed.setHours(0, 0, 0, 0);
        this.einstallenService.setCurrentEinstalldatum(parsed);
    }

    private draftToSammelnTier(draft: DashboardSammelstellePrefillTier): SammelnTier {
        const base = emptySammelnTier(draft.ohrmarke, draft.abteil ?? null);
        return {
            ...base,
            geschlecht: draft.geschlecht === 'm' || draft.geschlecht === 'w' ? draft.geschlecht : null,
            gewicht: String(draft.gewicht ?? ''),
            haendler: draft.haendler ?? null,
            haendlerId: draft.haendlerId ?? null,
            herkunft: draft.herkunft ?? null,
            herkunftKundeId: draft.herkunftKundeId ?? null,
            herkunftFields: draft.herkunftFields ?? null,
            abteil: draft.abteil ?? null,
            bemerkungen: [...(draft.bemerkungen ?? [])],
            reklamationen: [...(draft.reklamationen ?? [])],
            reklamationIds: [...(draft.reklamationIds ?? [])],
        };
    }

    /**
     * Create Sammelstelle drafts on the Einstall-Tierliste and apply in-air fields
     * (Gewicht, Abteil, …) only at this moment — not earlier in Sammelstelle.
     */
    private createPrefillTiereOnTierliste(options: {
        gruppeId: number;
        tierlisteId: number;
        tiere: DashboardSammelstellePrefillTier[];
        kundeId?: number | null;
        kpEinstalldatum?: string | null;
    }): Observable<ScanErgebnis[]> {
        const drafts = this.normalizePrefillTiere(options.tiere);
        if (!drafts.length) {
            return of([]);
        }
        const dateStr =
            String(options.kpEinstalldatum ?? '').trim() ||
            formatDate(new Date(), 'yyyy-MM-dd', 'de');
        this.applySammelstellePrefillDatum(dateStr);
        const kundeId = Number(options.kundeId || 0);

        return from(drafts).pipe(
            concatMap(draft => {
                const tier = this.draftToSammelnTier(draft);
                return this.sammelstelleSaveService
                    .createOnEinstallListe({
                        tier,
                        gruppeId: options.gruppeId,
                        kundeId: kundeId > 0 ? kundeId : null,
                        tierlisteId: options.tierlisteId,
                        datum: dateStr,
                    })
                    .pipe(
                        map(result => {
                            const gtId = Number(result?.gtId ?? 0);
                            if (!(gtId > 0)) {
                                return null;
                            }
                            const gewicht = parseGewichtKg(tier.gewicht);
                            if (gewicht != null && gewicht > 0) {
                                this.einstallenService.setPendingGewicht(gtId, gewicht);
                            }
                            const len = draft.ohrmarke.length;
                            const isPass = len === PASS_SCAN_LENGTH;
                            const scan = new ScanErgebnis();
                            scan.gt_id = gtId;
                            scan.success = true;
                            scan.ohrmarke_notnull = draft.ohrmarke;
                            scan.ohrmarke_gescannt = isPass ? 0 : 1;
                            scan.pass_gescannt = isPass ? 1 : 0;
                            scan.abteil = tier.abteil?.trim() || undefined;
                            if (gewicht != null && gewicht > 0) {
                                scan.einstallgewicht = gewicht;
                            }
                            return scan;
                        }),
                        catchError(err => {
                            this.messageService.errorMessage(
                                `Ohrmarke ${draft.ohrmarke} konnte nicht angelegt werden.`,
                                err,
                            );
                            return of(null);
                        }),
                    );
            }),
            toArray(),
            map(rows => rows.filter((s): s is ScanErgebnis => !!s)),
        );
    }

    private initContinueAbgangTierliste(): void {
        const cfg = this.dialogData?.continueAbgangTierliste;
        const tierlisteId = Number(cfg?.tierlisteId || 0);
        if (tierlisteId <= 0) {
            this.isLoadingGruppe = false;
            this.messageService.errorMessage('Ausstallliste kann nicht geöffnet werden.', null);
            return;
        }

        this.isLoadingGruppe = true;
        this.prefillInitializationDone = false;
        this.continueAbgangTierlisteSubscription?.unsubscribe();

        const tierlisteParams = new HttpParams().set('tierliste_id', String(tierlisteId));
        this.continueAbgangTierlisteSubscription = this.api
            .get(this.apiBaseUrl + 'tierliste/read_one_kundenportal.php', tierlisteParams)
            .pipe(
                switchMap((tierliste: Tierliste) => {
                    if (!tierliste?.tierliste_id) {
                        return throwError(() => new Error('Tierliste nicht gefunden'));
                    }
                    if (isTierlisteClosed(tierliste.status_id)) {
                        return throwError(() => new Error('Diese Ausstallliste ist bereits abgeschlossen.'));
                    }
                    const kundeId = Number(cfg?.kundeId || tierliste.kunde_id_abgang) || 0;
                    return forkJoin({
                        tierliste: of(tierliste),
                        _: this.ensureClientForContinueScan(kundeId),
                    });
                }),
                switchMap(({ tierliste }) => {
                    const transferInnerhalb = Number(tierliste.umstallen) === 1;
                    this.applyContinueAbgangTierlistePrefill(tierliste, transferInnerhalb);

                    if (Number(tierliste.mehrere_gruppen) > 0) {
                        this.tierQuelleGlobal = true;
                        this.tierQuelleGruppeId = null;
                        this.selectedGruppe = null;
                        this.gruppe = null;
                        return this.loadGruppenForContinueAbgang().pipe(map(() => tierliste));
                    }
                    const gruppeId = Number(tierliste.gruppe_id_abgang || 0);
                    if (gruppeId <= 0) {
                        return throwError(() => new Error('Gruppe der Ausstallliste nicht gefunden'));
                    }
                    return this.gruppenService.getGruppeKundenportal(gruppeId).pipe(
                        map(loadedGruppe => {
                            if (!loadedGruppe?.gruppe_id) {
                                throw new Error('Gruppe nicht gefunden');
                            }
                            this.tierQuelleGlobal = false;
                            this.tierQuelleGruppeId = loadedGruppe.gruppe_id;
                            this.selectedGruppe = loadedGruppe;
                            this.gruppe = loadedGruppe;
                            return tierliste;
                        }),
                    );
                }),
            )
            .subscribe({
                next: tierliste => {
                    this.refreshTierBrowseGruppeIds();
                    this.anzahlTiereInAbgangListe = Number(tierliste.anzahl_tiere ?? 0);
                    this.syncAbgangServiceListe(tierliste);
                    this.ensureAusstallenInputBuilt();
                    this.prefillZielbetriebFromTierliste(tierliste);
                    this.cdr.detectChanges();
                    this.finalizeContinueAbgangTierlisteSetup();
                },
                error: err => {
                    this.isLoadingGruppe = false;
                    this.messageService.errorMessage('Fehler beim Öffnen der Ausstallliste!', err);
                },
            });
    }

    private applyContinueAbgangTierlistePrefill(tierliste: Tierliste, transferInnerhalb: boolean): void {
        this.selectedAction = transferInnerhalb ? 'umstallen_intern' : 'ausstallen_extern';
        this.tierlisteMode = 'existing';
        this.selectedBestehendeTierliste = tierliste;
        this.tierauswahlAbgangsliste = tierliste;
        this.abgangTierliste = tierliste;
    }

    private getTierlisteZielKundeId(tierliste: Tierliste): number {
        return Number(tierliste.kunde_id_einstallen || 0) || Number(tierliste.kunde_id_zielbetrieb || 0);
    }

    /** Keep in-memory Abgangsliste refs in sync after partial API updates (e.g. Zielbetrieb). */
    private applyWorkingAbgangsTierliste(tierliste: Tierliste): void {
        const tierlisteId = Number(tierliste?.tierliste_id || 0);
        if (tierlisteId <= 0) {
            return;
        }
        if (Number(this.tierauswahlAbgangsliste?.tierliste_id || 0) === tierlisteId) {
            this.tierauswahlAbgangsliste = tierliste;
        }
        if (Number(this.selectedBestehendeTierliste?.tierliste_id || 0) === tierlisteId) {
            this.selectedBestehendeTierliste = tierliste;
        }
        this.abgangTierliste = tierliste;
        this.syncAbgangServiceListe(tierliste);
    }

    private loadGruppenForContinueAbgang(): Observable<Gruppe[]> {
        if (!this.hasClientChosen) {
            return of([]);
        }
        let params = new HttpParams();
        if (this.selectedClient?.kunde_id) {
            params = params.set('kunde_id', this.selectedClient.kunde_id.toString());
        }
        return this.api.getAll(this.apiBaseUrl + 'gruppe/read_akt_kundenportal.php', params).pipe(
            map(response => {
                this.gruppen = (response?.records || [])
                    .filter((gruppe: Gruppe) => this.isActiveGruppe(gruppe))
                    .sort((a: Gruppe, b: Gruppe) => {
                        const tierDiff = Number(b?.anzahl_tiere_aktuell || 0) - Number(a?.anzahl_tiere_aktuell || 0);
                        if (tierDiff !== 0) {
                            return tierDiff;
                        }
                        return String(a?.bezeichnung || '').localeCompare(String(b?.bezeichnung || ''), 'de');
                    });
                return this.gruppen;
            }),
        );
    }

    private prefillZielbetriebFromTierliste(tierliste: Tierliste): void {
        const zielKundeId = this.getTierlisteZielKundeId(tierliste);
        if (!this.isUmstallenIntern || zielKundeId <= 0) {
            return;
        }
        const params = new HttpParams().set('kunde_id', String(zielKundeId));
        this.api.get(this.apiBaseUrl + 'kunde/read_one_kundenportal.php', params).subscribe({
            next: (kunde: Client) => {
                if (kunde?.kunde_id) {
                    this.selectedZielbetrieb = kunde;
                    this.ensureAusstallenInputBuilt();
                    this.refreshCompactStepNav();
                    this.cdr.markForCheck();
                }
            },
        });
    }

    /** Prefilled Abgangsliste: start on „Tiere auswählen“ or final Ausstallen step. */
    private finalizeContinueAbgangTierlisteSetup(): void {
        const labels = this.buildStepLabels();
        this.maxVisitedStepIndex = Math.max(0, labels.length - 1);
        const openAtAusstallen = this.dialogData?.continueAbgangTierliste?.initialStep === 'ausstallen';

        const sync = (): void => {
            if (!this.stepper || !this.isAusstallenFlow) {
                return;
            }
            const targetIx = openAtAusstallen
                ? (this.materialStepIndexForLabel(this.ausstallenActionLabel) ??
                  this.stepIndexForLabel(this.ausstallenActionLabel) ??
                  Math.max(0, labels.length - 1))
                : (this.materialStepIndexForLabel('Tiere auswählen') ??
                  this.stepIndexForLabel('Tiere auswählen') ??
                  0);
            this.refreshCompactStepNav();
            this.navigateToStep(targetIx);
            this.cdr.detectChanges();
        };
        setTimeout(() => sync(), 0);
        setTimeout(() => sync(), 80);
        setTimeout(() => {
            sync();
            this.completePrefillInitialization();
        }, 200);
    }

    /** Material mat-step index (DOM order). Falls back to compact-nav index when labels use ng-template. */
    private materialStepIndexForLabel(label: string): number | null {
        const steps = this.stepper?.steps?.toArray() ?? [];
        for (let i = 0; i < steps.length; i++) {
            const raw = steps[i]?.label;
            const stepLabel = typeof raw === 'string' ? raw.trim() : '';
            if (stepLabel === label) {
                return i;
            }
        }
        return this.stepIndexForLabel(label);
    }

    /** Continue-scan: only Einstallen + Prüfen steps; refresh nav after stepper is in the DOM. */
    private finalizeContinueDirectScanSetup(): void {
        const einstallIx = this.stepIndexForLabel('Einstallen') ?? 0;
        const reviewIx = this.stepIndexForLabel('Prüfen & melden') ?? 1;
        this.maxVisitedStepIndex = Math.max(einstallIx, reviewIx);
        const openAtReview = this.isContinueDirectScanAtReviewStep;

        const sync = (): void => {
            this.refreshCompactStepNav();
            this.navigateToStep(openAtReview ? reviewIx : einstallIx);
        };
        setTimeout(() => sync(), 0);
        setTimeout(() => {
            sync();
            this.completePrefillInitialization();
        }, 50);
    }

    private mapContinueScanRecords(records: unknown[]): ScanErgebnis[] {
        return this.einstallenService.mapTierlisteScanRecords(records);
    }

    private ensureAusstallenInputBuilt(): void {
        if (!this.isAusstallenFlow) {
            this.ausstallenInput = null;
            return;
        }
        const workingTierliste = this.getWorkingAbgangsTierliste();
        const selectedTiere = this.getSelectedAusstallenTiere();
        const tiereAlreadyOnListe = Number(workingTierliste?.anzahl_tiere ?? 0) > 0;
        if (!workingTierliste?.tierliste_id || (selectedTiere.length === 0 && !tiereAlreadyOnListe)) {
            this.ausstallenInput = null;
            return;
        }
        const intern = this.selectedAction === 'umstallen_intern';
        const workingTierlisteId = Number(workingTierliste.tierliste_id || 0);
        const currentTierlisteId = Number(this.ausstallenInput?.tierliste?.tierliste_id || 0);
        const wantZielId = intern ? Number(this.selectedZielbetrieb?.kunde_id) : 0;
        const haveZielId = Number(this.ausstallenInput?.zielbetrieb?.kunde_id ?? 0);
        const wantGruppeId = Number(this.gruppe?.gruppe_id || this.tierQuelleGruppeId || 0);
        const haveGruppeId = Number(this.ausstallenInput?.gruppe_abgang?.gruppe_id || 0);
        const selectedTierIdsSignature = selectedTiere
            .map(tier => Number(tier?.gt_id))
            .filter(id => id > 0)
            .sort((a, b) => a - b)
            .join(',');
        const currentTierIdsSignature = (this.ausstallenInput?.tiere || [])
            .map(tier => Number(tier?.gt_id))
            .filter(id => id > 0)
            .sort((a, b) => a - b)
            .join(',');
        const needNew =
            !this.ausstallenInput ||
            (wantGruppeId > 0 && haveGruppeId !== wantGruppeId) ||
            (intern && haveZielId !== wantZielId) ||
            currentTierlisteId !== workingTierlisteId ||
            selectedTierIdsSignature !== currentTierIdsSignature;
        if (!needNew) {
            return;
        }
        const input = new AusstallenDialogInput(intern, !intern, {
            tierliste:
                intern && this.selectedZielbetrieb?.kunde_id
                    ? patchTierlisteFromInternZielbetrieb(
                          workingTierliste,
                          this.selectedZielbetrieb,
                          this.getStepperInhaberKundeId(),
                      )
                    : workingTierliste,
        });
        input.ausstallenderBetrieb = this.stammdatenService.getAusgewaehlteVvvo();
        if (this.gruppe?.gruppe_id) {
            input.gruppe_abgang = this.gruppe;
        }
        if (intern && this.selectedZielbetrieb) {
            input.zielbetrieb = this.selectedZielbetrieb;
        }
        input.tiere = tiereAlreadyOnListe ? [] : selectedTiere;
        this.ausstallenInput = input;
    }

    /** Checkbox aus dem Abschlussformular. Undefined, wenn das Formular die Flag nicht anbietet. */
    private gewichteImportierenFromForm(): number | undefined {
        const dlg = this.embeddedAusstallenDialog;
        if (!dlg?.showGewichteImportieren) {
            return undefined;
        }
        return dlg.gewichteImportierenCtrl.value ? 1 : 0;
    }

    /**
     * Kommentar aus dem Abschlussformular nur, wenn er dort geändert wurde.
     * Sonst fehlt das Feld im JSON und die Prozedur lässt den gespeicherten Text stehen.
     */
    private formKommentarForAbschluss(): string | undefined {
        return this.embeddedAusstallenDialog?.kommentarOverrideForSave();
    }

    private ohneUnveraendertenKommentar(payload: Tierliste): Tierliste {
        const override = this.formKommentarForAbschluss();
        if (override === undefined) {
            return ohneTierlisteKommentar(payload);
        }
        return { ...payload, kommentar: override };
    }

    /** Merge scan-step list + form save so abschliessen (162) has datum, Zielbetrieb, etc. */
    private buildTierlisteForAbschluss(saved: Tierliste): Tierliste {
        const working = this.getWorkingAbgangsTierliste();
        const dlg = this.embeddedAusstallenDialog;
        const intern = this.selectedAction === 'umstallen_intern';
        const rawDatum = dlg?.datumCtrl?.value ?? saved.datum_abgang ?? working?.datum_abgang;
        const datumAbgang = this.formatTierlisteDatumForApi(rawDatum) ?? rawDatum;
        const sourceKundeId = Number(
            this.gruppe?.kunde_id ||
                this.selectedClient?.kunde_id ||
                saved.kunde_id_abgang ||
                working?.kunde_id_abgang ||
                0,
        );
        let kundeIdEinstallen =
            saved.kunde_id_einstallen ??
            (intern ? this.selectedZielbetrieb?.kunde_id : saved.kunde_id_einstallen) ??
            working?.kunde_id_einstallen;
        if (intern && !(Number(kundeIdEinstallen) > 0) && sourceKundeId > 0) {
            kundeIdEinstallen = sourceKundeId;
        }
        const mergedForExtern: Tierliste = {
            ...(working ?? {}),
            ...saved,
            kunde_id_einstallen: kundeIdEinstallen,
            kunde_id_abgang: saved.kunde_id_abgang ?? working?.kunde_id_abgang ?? this.selectedClient?.kunde_id,
        };
        return {
            ...(working ?? {}),
            ...saved,
            tierliste_id: saved.tierliste_id ?? working?.tierliste_id,
            datum_abgang: datumAbgang,
            kunde_id_einstallen: kundeIdEinstallen,
            kunde_id_abgang: saved.kunde_id_abgang ?? working?.kunde_id_abgang ?? this.selectedClient?.kunde_id,
            gruppe_id_abgang: saved.gruppe_id_abgang ?? working?.gruppe_id_abgang ?? this.gruppe?.gruppe_id,
            kommentar: this.formKommentarForAbschluss() ?? saved.kommentar ?? working?.kommentar,
            tierliste_extern: intern
                ? resolveTierlisteExtern(mergedForExtern, this.gruppe?.kunde_id)
                : (saved.tierliste_extern ?? working?.tierliste_extern ?? 1),
            abgang_melden: saved.abgang_melden ?? working?.abgang_melden,
            mehrere_gruppen: saved.mehrere_gruppen ?? working?.mehrere_gruppen,
            anzahl_tiere: Math.max(
                Number(saved.anzahl_tiere ?? 0),
                Number(working?.anzahl_tiere ?? 0),
                this.anzahlTiereInAbgangListe,
            ),
        };
    }

    /** MySQL DATE via API expects yyyy-MM-dd, not a JSON Date object. */
    private formatTierlisteDatumForApi(value: unknown): string | null {
        if (value == null || value === '') {
            return null;
        }
        const date = value instanceof Date ? new Date(value.getTime()) : new Date(String(value));
        if (Number.isNaN(date.getTime())) {
            return null;
        }
        date.setHours(0, 0, 0, 0);
        return formatDate(date, 'yyyy-MM-dd', 'de', 'Europe/Berlin');
    }

    /** Animals added via scan/Hinzufügen are already on the list — do not bulk-add kandidaten again. */
    private getTiereStillToAddToAbgangsliste(tiere: GruppeTier[]): GruppeTier[] {
        const alreadyOnList = Number(this.tierauswahlAbgangsliste?.anzahl_tiere ?? this.anzahlTiereInAbgangListe ?? 0) > 0;
        if (alreadyOnList) {
            return [];
        }
        return (tiere || []).filter(t => Number(t?.gt_id) > 0);
    }

    private getWorkingAbgangsTierliste(): Tierliste | null {
        return this.tierauswahlAbgangsliste ?? this.selectedBestehendeTierliste ?? null;
    }

    private resetTierQuelleForAbgang(): void {
        this.tierQuelleGlobal = false;
        this.tierQuelleGruppeId = null;
        this.selectedGruppe = null;
        this.gruppe = null;
        this.tierBrowseGruppeIds = [];
    }

    private initTierauswahlAbgangScan(): void {
        if (!this.isAusstallenFlow || !this.hasTierlisteChoice || !this.canPrepareTierauswahlAbgang()) {
            return;
        }
        if (this.tierauswahlAbgangsliste?.tierliste_id && this.canReuseTierauswahlAbgangsliste()) {
            this.syncAbgangServiceListe(this.tierauswahlAbgangsliste);
            if (this.isAusstallenExtern) {
                this.prefillEmpfaengerFromWorkingTierliste();
            }
            this.cdr.markForCheck();
            return;
        }
        if (this.isPreparingTierauswahlAbgang) {
            return;
        }
        this.isPreparingTierauswahlAbgang = true;
        this.prepareTierauswahlAbgangSubscription?.unsubscribe();
        this.prepareTierauswahlAbgangSubscription = this.prepareTierauswahlAbgangsliste()
            .pipe(finalize(() => (this.isPreparingTierauswahlAbgang = false)))
            .subscribe({
                next: liste => {
                    if (!liste?.tierliste_id) {
                        return;
                    }
                    this.tierauswahlAbgangsliste = liste;
                    this.abgangTierliste = liste;
                    this.anzahlTiereInAbgangListe = Number(liste.anzahl_tiere ?? 0);
                    this.syncAbgangServiceListe(liste);
                    this.ensureAusstallenInputBuilt();
                    if (this.isAusstallenExtern) {
                        this.prefillEmpfaengerFromWorkingTierliste();
                    }
                    this.cdr.markForCheck();
                },
                error: err => {
                    this.messageService.errorMessage('Fehler beim Vorbereiten der Ausstallliste!', err);
                },
            });
    }

    private canPrepareTierauswahlAbgang(): boolean {
        if (!this.isAusstallenFlow) {
            return false;
        }
        if (this.tierQuelleGlobal) {
            return true;
        }
        return !!(this.tierQuelleGruppeId && this.tierQuelleGruppeId > 0);
    }

    private canReuseTierauswahlAbgangsliste(): boolean {
        if (!this.tierauswahlAbgangsliste?.tierliste_id) {
            return false;
        }
        if (this.tierQuelleGlobal || this.isGlobalAbgangsliste) {
            return true;
        }
        const gruppeId = Number(this.tierQuelleGruppeId || this.gruppe?.gruppe_id || 0);
        return Number(this.tierauswahlAbgangsliste.gruppe_id_abgang) === gruppeId;
    }

    private prepareTierauswahlAbgangsliste(): Observable<Tierliste> {
        const gruppeId = this.tierQuelleGlobal
            ? 0
            : Number(this.tierQuelleGruppeId || this.gruppe?.gruppe_id || 0);
        const keepListeGruppeUnchanged = this.isGlobalAbgangsliste || this.tierQuelleGlobal;
        if (this.tierlisteMode === 'existing' && this.selectedBestehendeTierliste?.tierliste_id) {
            return this.api
                .getByIdAlternative(
                    this.apiBaseUrl + 'tierliste/read_one_kundenportal.php',
                    'tierliste_id',
                    String(this.selectedBestehendeTierliste.tierliste_id),
                )
                .pipe(
                    map(liste =>
                        keepListeGruppeUnchanged ? liste : { ...liste, gruppe_id_abgang: gruppeId },
                    ),
                );
        }
        const payload = new Tierliste();
        if (this.tierQuelleGlobal) {
            payload.mehrere_gruppen = 1;
        } else {
            payload.gruppe_id_abgang = gruppeId > 0 ? gruppeId : undefined;
            payload.mehrere_gruppen = 0;
        }
        payload.datum_abgang = new Date();
        payload.haendler_uebernehmen = 0;
        payload.tierliste_extern = this.selectedAction === 'ausstallen_extern' ? 1 : 0;
        payload.umstallen = this.selectedAction === 'umstallen_intern' ? 1 : 0;
        if (this.selectedClient?.kunde_id) {
            payload.kunde_id_abgang = this.selectedClient.kunde_id;
        }
        return this.api.post(this.apiBaseUrl + 'tierliste/create_kundenportal.php', payload, undefined);
    }

    private syncAbgangServiceListe(tierliste: Tierliste): void {
        const keepListeGruppeUnchanged = this.isGlobalAbgangsliste || this.tierQuelleGlobal;
        const liste: Tierliste = keepListeGruppeUnchanged
            ? { ...tierliste }
            : {
                  ...tierliste,
                  gruppe_id_abgang: this.tierQuelleGruppeId ?? this.gruppe?.gruppe_id ?? tierliste.gruppe_id_abgang,
              };
        this.abgangService.setAbgangsliste(liste, true, true);
    }

    private resetWorkflowState(clearGruppen: boolean): void {
        const keepIndex = this.stepper?.selectedIndex;
        this.selectedAction = clearGruppen ? null : this.selectedAction;
        this.selectedGruppe = null;
        this.gruppe = null;
        this.selectedZielbetrieb = null;
        this.empfaengerSchlachthof = null;
        this.empfaengerKontakte = [];
        this.empfaengerDisplayEntries = [];
        this.tierSucheCtrl.setValue('');
        this.ausstallenTierKandidaten = [];
        this.selectedAusstallenTierIds.clear();
        this.tierlisteMode = null;
        this.bestehendeTierlisten = [];
        this.bestehendeTierlistenLoaded = false;
        this.lastAppliedTierlistenLoadContextKey = null;
        this.tierlistenStepRefreshPending = false;
        this.selectedBestehendeTierliste = null;
        this.tierauswahlAbgangsliste = null;
        this.tierQuelleGlobal = false;
        this.tierQuelleGruppeId = null;
        this.ausstallenInput = null;
        this.abgangTierliste = null;
        this.anzahlTiereInAbgangListe = 0;
        this.overview = this.createEmptyOverview();
        this.showEinstallenOverview = false;
        if (clearGruppen) {
            this.gruppen = [];
        }
        this.maxVisitedStepIndex =
            typeof keepIndex === 'number' && keepIndex >= 0 ? keepIndex : clearGruppen ? STEP_KUNDE : STEP_AKTION;
        this.refreshCompactStepNav();
    }

    private createEmptyOverview(): EinstallenMeldenOverview {
        return {
            anzahlPassUndOhrmarke: 0,
            anzahlPass: 0,
            anzahlOhrmarke: 0,
            anzahlCsv: 0,
            nichtMeldbar: 0,
        };
    }

    private isActiveGruppe(gruppe: Gruppe): boolean {
        return isGruppeSichtbarFuerAusstallenUmstallen(gruppe);
    }

    formatGruppeAbschnitt(gruppe: Gruppe | null | undefined): string {
        const abschnitt = String(gruppe?.produktionsabschnitt || '').trim();
        return abschnitt || '—';
    }

    private loadAusstallenTierKandidaten(): void {
        if (!this.gruppe?.gruppe_id) {
            this.ausstallenTierKandidaten = [];
            this.selectedAusstallenTierIds.clear();
            this.ensureAusstallenInputBuilt();
            return;
        }
        this.isLoadingAusstallenTiere = true;
        this.ausstallenTiereSubscription?.unsubscribe();
        const params = new HttpParams().set('gruppe_id', String(this.gruppe.gruppe_id));
        this.ausstallenTiereSubscription = this.api
            .getAll(this.apiBaseUrl + 'gruppe_tier/read_scan_kundenportal.php', params)
            .pipe(finalize(() => (this.isLoadingAusstallenTiere = false)))
            .subscribe({
                next: response => {
                    const records = (response?.records || []) as GruppeTier[];
                    this.ausstallenTierKandidaten = records.filter(tier => this.canTierBeAddedToAusstallenListe(tier));
                    this.selectedAusstallenTierIds.clear();
                    this.ensureAusstallenInputBuilt();
                },
                error: err => {
                    this.messageService.errorMessage('Fehler beim Laden der Tiere!', err);
                    this.ausstallenTierKandidaten = [];
                    this.selectedAusstallenTierIds.clear();
                    this.ensureAusstallenInputBuilt();
                },
            });
    }

    /** Liste wählen always loads per Betrieb (`kunde_id`). `gruppe_id_abgang` would filter counts to one group (mostly 0). */
    private getTierlistenLoadContextKey(): string | null {
        if (this.selectedClient?.kunde_id) {
            return `kunde:${this.selectedClient.kunde_id}`;
        }
        return null;
    }

    private needsTierlistenReload(): boolean {
        const contextKey = this.getTierlistenLoadContextKey();
        if (!contextKey) {
            return false;
        }
        return !this.bestehendeTierlistenLoaded || contextKey !== this.lastAppliedTierlistenLoadContextKey;
    }

    /** Re-fetch on revisit so totals stay current; never use Gruppe filter for display counts. */
    private refreshTierlistenOnListeStepEnter(): void {
        if (!this.showTierlisteAuswahlStep || !this.selectedClient?.kunde_id) {
            return;
        }
        if (this.isLoadingBestehendeTierlisten) {
            return;
        }
        const force = this.bestehendeTierlistenLoaded;
        if (!force && !this.needsTierlistenReload()) {
            return;
        }
        this.loadBestehendeTierlisten({ force });
    }

    getTierlisteTiereAnzeige(tierliste: Tierliste): number {
        if (tierliste?.anzahl_tiere_gesamt != null) {
            return Number(tierliste.anzahl_tiere_gesamt);
        }
        return Number(tierliste?.anzahl_tiere || 0);
    }

    getBestehendeTierlisteGruppeLabel(tierliste: Tierliste): string {
        if (isAbgangTierlisteGlobal(tierliste)) {
            return 'Global';
        }
        return (tierliste?.gruppe_abgang || '').trim() || '—';
    }

    getBestehendeTierlisteBemerkung(tierliste: Tierliste): string {
        return (tierliste?.kommentar || '').trim();
    }

    private loadBestehendeTierlisten(options?: { force?: boolean }): void {
        if (!this.isAusstallenFlow) {
            this.bestehendeTierlisten = [];
            this.selectedBestehendeTierliste = null;
            this.tierlisteMode = null;
            this.ensureAusstallenInputBuilt();
            return;
        }
        const contextKey = this.getTierlistenLoadContextKey();
        if (!contextKey) {
            this.bestehendeTierlisten = [];
            this.selectedBestehendeTierliste = null;
            this.ensureAusstallenInputBuilt();
            return;
        }

        const params = new HttpParams().set('kunde_id', String(this.selectedClient!.kunde_id));

        const requestId = ++this.loadBestehendeTierlistenRequestId;
        const previousSelectedId = Number(this.selectedBestehendeTierliste?.tierliste_id || 0);
        const force = !!options?.force;

        this.isLoadingBestehendeTierlisten = true;
        this.bestehendeTierlistenLoaded = false;
        if (force) {
            this.tierlistenStepRefreshPending = true;
        }
        this.bestehendeTierlistenSubscription?.unsubscribe();
        this.bestehendeTierlistenSubscription = this.api
            .get(this.apiBaseUrl + 'tierliste/read_meine_tierlisten.php', params)
            .pipe(
                finalize(() => {
                    if (requestId !== this.loadBestehendeTierlistenRequestId) {
                        return;
                    }
                    this.isLoadingBestehendeTierlisten = false;
                    this.bestehendeTierlistenLoaded = true;
                    this.tierlistenStepRefreshPending = false;
                }),
            )
            .subscribe({
                next: response => {
                    if (requestId !== this.loadBestehendeTierlistenRequestId) {
                        return;
                    }
                    if (contextKey !== this.getTierlistenLoadContextKey()) {
                        return;
                    }

                    const all = (response?.records || []) as Tierliste[];
                    this.bestehendeTierlisten = all.filter(t => Number(t?.status_id || 0) < 162);
                    this.lastAppliedTierlistenLoadContextKey = contextKey;

                    if (previousSelectedId > 0) {
                        const stillSelected = this.bestehendeTierlisten.find(
                            t => Number(t?.tierliste_id) === previousSelectedId,
                        );
                        this.selectedBestehendeTierliste = stillSelected ?? null;
                    }

                    if (this.bestehendeTierlisten.length === 0) {
                        this.selectedBestehendeTierliste = null;
                        if (this.tierlisteMode === 'existing') {
                            this.tierlisteMode = null;
                        }
                    }
                    this.ensureAusstallenInputBuilt();
                },
                error: err => {
                    if (requestId !== this.loadBestehendeTierlistenRequestId) {
                        return;
                    }
                    this.messageService.errorMessage('Fehler beim Laden bestehender Listen!', err);
                    this.bestehendeTierlisten = [];
                    this.selectedBestehendeTierliste = null;
                    this.lastAppliedTierlistenLoadContextKey = null;
                    if (this.tierlisteMode === 'existing') {
                        this.tierlisteMode = null;
                    }
                    this.ensureAusstallenInputBuilt();
                },
            });
    }

    private addSelectedTiereToTierliste(tierliste: Tierliste, tiere: GruppeTier[]): Observable<Tierliste> {
        const validTiere = (tiere || []).filter(t => Number(t?.gt_id) > 0);
        if (!tierliste?.tierliste_id || validTiere.length === 0) {
            return of(tierliste);
        }
        const payload = {
            tierliste_id: tierliste.tierliste_id,
            gruppen_tiere: validTiere,
            gruppe_id: this.gruppe?.gruppe_id ?? undefined,
        };
        return this.api.post(this.apiBaseUrl + 'tierliste/abgang_kundenportal.php', payload, undefined);
    }

    private getSelectedAusstallenTiere(): GruppeTier[] {
        if (!this.isAusstallenFlow) {
            return [];
        }
        return this.ausstallenTierKandidaten.filter(tier => this.selectedAusstallenTierIds.has(Number(tier?.gt_id)));
    }

    private canTierBeAddedToAusstallenListe(tier: GruppeTier): boolean {
        return !tier?.tierliste_id && tier?.hit_todesdatum == null && tier?.kp_todesdatum == null && tier?.hit_abgangsdatum == null;
    }
}
